<template>
  <!-- 类型 多选 单选 -->

  <div class="new-order-box">
    <div
      class="new-order common-rowUnder"
      :style="{
        height: 'calc(100vh - 60px)',
        overflowY: 'auto',
        background: '#fff',
      }"
    >
      <!-- <button @click="submit">提交</button> -->
      <!-- 顶部步骤条 -->
      <div class="new-order-step">
        <div class="common-flex" style="width: 1420px; margin: 0 auto">
          <div class="new-order-select">
            <Select
              v-model="productId"
              @on-change="changeProduct"
              placeholder=" "
              size="small"
              style="width: 100px"
            >
              <Option
                v-for="item in getCategoryList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </div>
          <div class="common-flex">
            <div
              class="common-flex step-item common-align-center"
              v-for="(item, index) in stepList"
              :key="index"
            >
              <div class="step-item-name">
                {{ item.name }}
                <div v-if="stepId == item.step" class="step-item-choose"></div>
              </div>
              <Icon style="margin: 0 33px 0 39px" type="ios-arrow-forward" />
            </div>
          </div>
        </div>
      </div>
      <!-- 对应步骤 -->
      <!-- 第一 二步 -->
      <div class="step-o-box common-flex" v-show="stepId != 3">
        <!-- 第一步 -->
        <div
          class="details-choose common-rowUnder"
          :style="{
            height: 'calc(100vh - 84px)',
            overflowY: 'auto',
            paddingBottom: '50px',
          }"
          v-show="stepId == 1"
        >
          <div class="step-o-box-title">{{ $t("newOrder.jeansDetails") }}</div>
          <!-- 面料 -->
          <div class="step-box-modular">
            <div
              class="
                common-flex common-align-center common-justify-between
                step-box-title-box
              "
            >
              <div class="title">{{ $t("newOrder.fabric") }}</div>
              <div>
                <!-- <Input
                  :placeholder="$t('newOrder.placeCommon')"
                  style="width: 260px"
                >
                  <Icon type="ios-search" slot="suffix" />
                </Input> -->
                <form>
                  <Select
                    prefix="ios-search"
                    @on-change="changeFabri"
                    clearable
                    @on-query-change="queryChangeFabri"
                    style="width: 260px"
                    :placeholder="$t('newOrder.placeCommon')"
                    :not-found-text="$t('noDate')"
                    filterable
                  >
                    <!-- v-model="searchKey.fabric" -->
                    <Option
                      v-for="item in fabricListSearch"
                      :value="item.id"
                      :key="item.id"
                      >{{ item.fabricCode }}</Option
                    >
                  </Select>
                </form>
              </div>
            </div>
            <div class="common-flex common-flex-wrap">
              <rInputBox
                @iptValue="iptValue"
                @chooseCtm="chooseCtm"
                :iptFabric="iptFabric"
                :checks="ctmShow"
                @fabricFocus="fabricFocus"
              ></rInputBox>
              <!-- :chooseIndex="params.fabricIndex" -->
              <rImageChoose
                @previewImg="previewImg"
                boxType="fabric"
                @select="fabricsSlect"
                :index="index"
                :config="item"
                v-for="(item, index) in fabricList"
                :key="index"
                v-if="index < 13"
              ></rImageChoose>
            </div>
          </div>
          <!-- 选择辅料 刺绣等 -->
          <div
            v-if="categroyMsg && allItem.craftList.length > 0"
            v-for="(allItem, allIndex) in categroyMsg"
            :key="allIndex"
            :id="'cloth' + allIndex"
          >
            <div
              class="title"
              v-if="allItem.accessories.length > 0"
              style="margin: 10px 0"
            >
              {{ $t("newOrder.accessories") }}
            </div>

            <div @click="changeChooseIndex(allIndex)">
              <div class="categroy-name">{{ allItem.name }}</div>
              <div v-for="(item, index) in allItem.accessories" :key="index">
                <rOrderChooseCraft :config="item"></rOrderChooseCraft>
              </div>
              <!-- 展开刺绣 -->
              <div class="title" style="margin: 10px 0">
                {{ $t("newOrder.embroidery") }}
              </div>

              <div v-if="allItem.emb && allItem.emb.length > 0">
                <Collapse
                  class="collapse"
                  v-for="(eitem, eindex) in allItem.emb"
                  :key="eindex"
                >
                  <Panel name="1" :hide-arrow="true">
                    <div
                      class="
                        common-flex common-justify-between common-align-center
                      "
                    >
                      <div class="common-flex common-align-center">
                        <Checkbox
                          @click="checksPreventDefault"
                          v-model="eitem.check"
                        ></Checkbox>
                        <div
                          style="
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            width: 410px;
                          "
                        >
                          {{ eitem.name }}
                        </div>
                      </div>
                      <!-- -->
                      <div
                        v-if="
                          eitem.embContent.embContent != '' &&
                          eitem.embContent.color &&
                          eitem.embContent.font &&
                          (eitem.embSize && eitem.embSize.length > 0
                            ? eitem.embContent.embSize
                            : true)
                        "
                      >
                        <div class="complete">
                          {{ $t("newOrder.Complete") }}
                        </div>
                      </div>
                    </div>
                    <div slot="content">
                      <div
                        class="common-flex common-align-center"
                        v-if="
                          eitem.currentExtension &&
                          eitem.currentExtension === 'file'
                        "
                      >
                        <Upload
                          :headers="uploadHeaders"
                          :action="baseUrl + 'pc/attachment/upload'"
                          :data="uploadData"
                          :show-upload-list="false"
                          accpet="image/*"
                          :format="['png', 'jpg', 'jpeg']"
                          :max-size="2048"
                          :on-success="
                            (response, file, fileList) => {
                              handleUploadSuccess(
                                response,
                                file,
                                fileList,
                                eitem
                              );
                            }
                          "
                          :on-error="handleEmbUploadError"
                          style="
                            display: inline-block;
                            width: 58px;
                            margin-right: 10px;
                          "
                        >
                          <div class="upload-icon">
                            <Icon type="ios-camera" size="20"></Icon>
                          </div>
                        </Upload>
                        <div
                          class="upload-icon"
                          v-if="eitem.urlPath"
                          style="display: inline-block"
                        >
                          <img :src="eitem.urlPath" alt="" />
                        </div>
                      </div>

                      <input
                        v-else
                        class="collapse-input"
                        :data-eindex="eindex"
                        :data-allIndex="allIndex"
                        :value="eitem.embContent.embContent"
                        @input="embContents"
                        :placeholder="$t('newOrder.monogramConten')"
                        type="text"
                      />
                      <div
                        v-if="eitem.embColor && eitem.embColor.length > 0"
                        class="
                          collapse-search
                          common-align-center common-flex common-justify-between
                        "
                      >
                        <div class="collapse-title">Color</div>
                        <form>
                          <rSearchEmb
                            @queryChange="queryChangeColor"
                            @change="changeColor"
                            :config="eitem"
                            :list="searchColor"
                          ></rSearchEmb>
                        </form>
                      </div>
                      <div class="common-flex common-flex-wrap">
                        <div
                          v-for="(ritem, rindex) in eitem.embColor"
                          :key="ritem.id"
                        >
                          <rImageChoose
                            boxType="emb"
                            @select="colorSelect"
                            :index="rindex"
                            :config="ritem"
                            :parent="eitem"
                            marginRight="16px"
                          ></rImageChoose>
                        </div>
                      </div>
                      <!-- 尺寸 -->
                      <div
                        v-if="eitem.embSize && eitem.embSize.length > 0"
                        class="
                          collapse-search
                          common-align-center common-flex common-justify-between
                        "
                      >
                        <div class="collapse-title">Size</div>
                        <form>
                          <rSearchEmb
                            @queryChange="queryChangeSize"
                            @change="changeSize"
                            :config="eitem"
                            :list="searchSize"
                          ></rSearchEmb>
                        </form>
                      </div>
                      <div class="common-flex common-flex-wrap">
                        <div
                          v-for="(ritem, rindex) in eitem.embSize"
                          :key="ritem.id"
                        >
                          <rImageChoose
                            boxType="emb"
                            @select="sizeSelect"
                            :index="rindex"
                            :config="ritem"
                            :parent="eitem"
                            marginRight="16px"
                          ></rImageChoose>
                        </div>
                      </div>
                      <!-- 字体 -->
                      <div
                        v-if="eitem.embFont && eitem.embFont.length > 0"
                        class="
                          collapse-search
                          common-align-center common-flex common-justify-between
                        "
                      >
                        <div class="collapse-title">Font</div>
                        <form>
                          <rSearchEmb
                            @queryChange="queryChangeFont"
                            @change="changeFont"
                            :config="eitem"
                            :list="searchFont"
                          ></rSearchEmb>
                        </form>
                      </div>
                      <div class="common-flex common-flex-wrap">
                        <div
                          v-for="(ritem, rindex) in eitem.embFont"
                          :key="ritem.id"
                        >
                          <rImageChoose
                            boxType="emb"
                            @select="fontSelect"
                            :index="rindex"
                            :config="ritem"
                            :parent="eitem"
                            marginRight="16px"
                          ></rImageChoose>
                        </div>
                      </div>
                    </div>
                  </Panel>
                </Collapse>
              </div>
              <!-- 撞色信息 -->
              <div
                v-if="allItem.colorContrast && allItem.colorContrast.length > 0"
                class="title"
                style="margin-top: 10px"
              >
                {{ $t("newOrder.colorContrast") }}
              </div>
              <div
                v-if="allItem.colorContrast && allItem.colorContrast.length > 0"
              >
                <Collapse
                  class="collapse"
                  v-for="(eitem, eindex) in allItem.colorContrast"
                  :key="eindex"
                >
                  <Panel name="1" :hide-arrow="true">
                    <div
                      class="
                        common-flex common-justify-between common-align-center
                      "
                    >
                      <div class="common-flex common-align-center">
                        <Checkbox v-model="eitem.check"></Checkbox>
                        <div
                          style="
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            width: 410px;
                          "
                        >
                          {{ eitem.name }}
                        </div>
                      </div>
                      <div v-if="eitem.chooseFabric">
                        <div class="complete">
                          {{ $t("newOrder.Complete") }}
                        </div>
                      </div>
                    </div>
                    <div slot="content">
                      <div
                        class="
                          collapse-search
                          common-align-center common-flex common-justify-between
                        "
                      >
                        <div class="collapse-title">Monogram Font</div>
                        <form>
                          <rSearchEmb
                            @queryChange="queryChangeContrast"
                            @change="changeContrast"
                            :config="eitem"
                            :list="searchContrast"
                          ></rSearchEmb>
                        </form>
                      </div>
                      <div class="common-flex common-flex-wrap">
                        <div
                          v-for="(ritem, rindex) in eitem.colorContrastFabric"
                          :key="ritem.id"
                        >
                          <rImageChoose
                            @previewImg="previewImg"
                            boxType="fabric"
                            @select="contrastSelect"
                            :index="rindex"
                            :config="ritem"
                            :parent="eitem"
                            marginRight="16px"
                          ></rImageChoose>
                        </div>
                      </div>
                    </div>
                  </Panel>
                </Collapse>
              </div>
            </div>
          </div>
          <Button class="step-btn-next" @click="next"
            >{{ $t("newOrder.next") }} ></Button
          >
        </div>
        <!-- 第二步 -->
        <div
          class="details-choose common-rowUnder"
          :style="{ height: 'calc(100vh - 84px)', overflowY: 'auto' }"
          v-show="stepId == 2"
        >
          <div class="step-o-box-title">Details</div>
          <!-- 选择工艺 -->
          <div
            v-for="(allItem, allIndex) in categroyMsg"
            :key="allIndex"
            :id="'cloths' + allIndex"
          >
            <div class="categroy-name">{{ allItem.name }}</div>
            <div v-for="(item, index) in allItem.craft" :key="index">
              <rOrderChooseCraft
                @craftSelect="craftSelect"
                :config="item"
              ></rOrderChooseCraft>
            </div>
          </div>
          <Button class="step-btn-previous" @click="previous"
            >< {{ $t("newOrder.previous") }}</Button
          >
          <Button class="step-btn-next" @click="next"
            >{{ $t("newOrder.next") }} ></Button
          >
        </div>
        <div class="details-content common-flex common-justify-between">
          <div>
            <img
              v-if="
                rightDetails.detailList.length > 0 &&
                rightDetails.detailList[rightDetails.chooseIndex].url
              "
              class="details-content-img"
              :src="rightDetails.detailList[rightDetails.chooseIndex].url"
              alt=""
            />
            <img
              v-else
              class="details-content-img"
              src="../../assets/images/none-img.png"
              alt=""
            />
            <div
              class="common-flex common-justify-around"
              style="margin-left: 95px; margin-top: 10px"
            >
              <div
                class="details-banner-img-box common-flex"
                v-for="(item, index) in rightDetails.detailList"
                :key="index"
                @click="changeJeans(index)"
              >
                <img
                  class="details-banner-img"
                  :src="item.url"
                  @error="imgError(item)"
                  alt=""
                  v-if="item.url"
                />
                <img
                  v-if="item.url == ''"
                  class="details-banner-img"
                  src="../../assets/images/none-img.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div
            class="details-content-integration common-rowUnder"
            :style="{ height: 'calc(100vh - 84px)', overflowY: 'auto' }"
          >
            <rIntegration
              style="margin-bottom: 61px"
              @chooseCustomer="chooseCustomer"
              :customerId="submitOrder.customerId"
              :customerName="submitOrder.customerName"
              :customerList="customerList"
              :customerInfoShow="customerInfoShow"
            ></rIntegration>
            <!-- 显示面料 -->
            <div class="details-content-msg" v-if="rightDetails.fabric.name">
              <div class="msg-item common-flex">
                <img
                  v-if="rightDetails.fabric.url"
                  :src="rightDetails.fabric.url"
                  @error="imgError(rightDetails.fabric)"
                  alt=""
                />
                <img
                  v-else
                  src="../../assets/images/none-img.png"
                  @error="imgError(rightDetails.fabric)"
                  alt=""
                />
                <div style="width: 100%">
                  <div class="msg-item-title">{{ $t("newOrder.fabric") }}</div>
                  <div
                    style="margin-top: 4px"
                    class="
                      common-flex common-justify-between common-align-center
                    "
                  >
                    <div style="text-align: left; color: #949494">
                      {{ rightDetails.fabric.name }}
                    </div>
                    <div><Icon type="ios-arrow-forward" /></div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 显示工艺 -->
            <div
              class="details-content-msg"
              style="margin-top: 0"
              v-if="
                rightDetails.detailList[rightDetails.chooseIndex] &&
                rightDetails.detailList[rightDetails.chooseIndex].craftList &&
                rightDetails.detailList[rightDetails.chooseIndex].craftList
                  .length > 0
              "
            >
              <div
                class="msg-item common-flex"
                v-for="(item, index) in rightDetails.detailList[
                  rightDetails.chooseIndex
                ].craftList"
                :key="index"
              >
                <div class="msg-item-price" v-if="item.price">
                  {{ item.price }}
                </div>
                <img
                  v-if="item.url"
                  @error="imgError(item)"
                  :src="item.url"
                  alt=""
                />
                <img v-else src="../../assets/images/none-img.png" alt="" />
                <div style="width: 100%">
                  <div class="msg-item-title">{{ item.parentName }}</div>
                  <div
                    style="margin-top: 4px"
                    class="
                      common-flex common-justify-between common-align-center
                    "
                  >
                    <div style="text-align: left; color: #949494">
                      {{ item.name }}
                    </div>
                    <div><Icon type="ios-arrow-forward" /></div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 显示刺绣 -->
            <div
              class="details-content-msg"
              style="margin-top: 0"
              v-if="
                rightDetails.detailList[rightDetails.chooseIndex] &&
                rightDetails.detailList[rightDetails.chooseIndex].embList &&
                rightDetails.detailList[rightDetails.chooseIndex].embList
                  .length > 0
              "
            >
              <div
                class="msg-item common-flex"
                v-for="(item, index) in rightDetails.detailList[
                  rightDetails.chooseIndex
                ].embList"
                :key="index"
              >
                <img
                  v-if="item.url"
                  @error="imgError(item)"
                  :src="item.url"
                  alt=""
                />
                <img v-else src="../../assets/images/none-img.png" alt="" />
                <div style="width: 100%">
                  <div class="msg-item-title">{{ item.name }}</div>
                  <div
                    style="margin-top: 4px"
                    class="
                      common-flex common-justify-between common-align-center
                    "
                  >
                    <div>
                      <div
                        v-if="item.colorName"
                        style="text-align: left; color: #949494"
                      >
                        颜色:{{ item.colorName }}
                      </div>
                      <div
                        v-if="item.fontName"
                        style="text-align: left; color: #949494"
                      >
                        字体:{{ item.fontName }}
                      </div>
                      <div
                        v-if="item.embSizeName"
                        style="text-align: left; color: #949494"
                      >
                        大小:{{ item.embSizeName }}
                      </div>
                    </div>
                    <div><Icon type="ios-arrow-forward" /></div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 显示撞色 -->
            <div
              class="details-content-msg"
              style="margin-top: 0"
              v-if="
                rightDetails.detailList[rightDetails.chooseIndex] &&
                rightDetails.detailList[rightDetails.chooseIndex]
                  .colorContrast &&
                rightDetails.detailList[rightDetails.chooseIndex].colorContrast
                  .length > 0
              "
            >
              <div
                class="msg-item common-flex"
                v-for="(item, index) in rightDetails.detailList[
                  rightDetails.chooseIndex
                ].colorContrast"
                :key="index"
              >
                <img
                  v-if="item.url"
                  @error="imgError(item)"
                  :src="item.url"
                  alt=""
                />
                <img v-else src="../../assets/images/none-img.png" alt="" />
                <div style="width: 100%">
                  <div class="msg-item-title">{{ item.name }}</div>
                  <div
                    style="margin-top: 4px"
                    class="
                      common-flex common-justify-between common-align-center
                    "
                  >
                    <div>
                      <div style="text-align: left; color: #949494">
                        {{ item.fabricCode }}
                      </div>
                    </div>
                    <div><Icon type="ios-arrow-forward" /></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 第三步 -->
      <div v-show="stepId == 3" class="customer-msg">
        <!-- 客户信息 -->
        <div class="customer-info">
          <div class="common-flex">
            <div style="text-align: left">
              <div class="title">{{ $t("newOrder.tailored") }}</div>
              <Select
                v-model="specBodyParams.sizeType"
                @on-change="changeTailored"
                :placeholder="$t('newOrder.placeholder')"
                style="width: 300px; margin: 10px 0"
              >
                <Option
                  v-for="item in tailoredList"
                  :value="item.id"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </div>
            <div v-if="isAddShow" style="text-align: left; margin-left: 40px">
              <div class="title">{{ $t("newOrder.suit") }}</div>
              <Select
                v-model="submitOrder.addProduct"
                :placeholder="$t('newOrder.placeholder')"
                style="width: 300px; margin: 10px 0"
              >
                <Option
                  v-for="item in isAddList"
                  :value="item.id"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </div>
            <div v-if="false" style="text-align: left; margin-left: 40px">
              <div class="title">{{ $t("newOrder.style") }}</div>
              <Select
                v-model="submitOrder.style"
                :placeholder="$t('newOrder.placeholder')"
                style="width: 300px; margin: 10px 0"
              >
                <Option
                  v-for="item in longShort"
                  :value="item.id"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </div>
          </div>
          <div
            class="
              customer-info-title
              common-align-center common-flex common-justify-between
            "
          >
            <div class="title">{{ $t("newOrder.customerInfo") }}</div>
            <rIntegration
              @chooseCustomer="chooseCustomer"
              :customerId="submitOrder.customerId"
              :customerName="submitOrder.customerName"
              :customerList="customerList"
              :customerInfoShow="customerInfoShow"
            ></rIntegration>
          </div>
          <!-- 基本信息 -->
          <div class="basic-info">
            <div class="basic-info-title" style="margin-bottom: 22px">
              {{ $t("newOrder.basicInformation") }}
            </div>
            <div class="common-flex common-flex-wrap customer-box">
              <div
                v-for="(item, index) in basicList"
                :key="index"
                style="text-align: left"
              >
                <rIpt
                  width="427"
                  v-if="item.type == 'input'"
                  :config="item"
                ></rIpt>
                <rIptSelect
                  width="427"
                  v-if="item.type == 'iptSelect'"
                  :config="item"
                  :iptWidth="item.iptWidth"
                  :index="index"
                  @changeIptSelect="changeIptSelect"
                ></rIptSelect>
                <rSelect
                  width="427"
                  v-if="item.type == 'select'"
                  :config="item"
                ></rSelect>
                <rInputDate
                  width="427"
                  v-if="item.type == 'date'"
                  :config="item"
                ></rInputDate>
              </div>
              <rIpt
                style="text-align: left"
                :width="428"
                :config="params.orderMsg"
              ></rIpt>
            </div>
          </div>
        </div>
        <!-- 特体信息 -->
        <div class="dress-style" v-if="styleList.length > 0">
          <div class="dress-style-title">{{ $t("newOrder.bodyPosture") }}</div>
          <div class="common-flex">
            <rDressStyle
              :styleList="styleList"
              @changeStyle="changeStyle"
            ></rDressStyle>
            <div class="dress-img" v-if="chooseStyleMsg.chooseStyleImg">
              <img :src="chooseStyleMsg.chooseStyleImg" alt="" />
              <div>{{ chooseStyleMsg.chooseStyleContent }}</div>
            </div>
          </div>
        </div>
        <!-- 着装风格 -->
        <div class="clothing" v-if="clothing.length > 0"></div>
        <!-- ;量体信息 -->
        <div class="measurements">
          <div
            @click="submit('size')"
            class="common-flex common-justify-between common-align-center"
            style="width: 894px; margin-bottom: 15px"
          >
            <div class="measurements-title" style="margin-bottom: 0">
              {{ $t("newOrder.dressStyle") }}
            </div>
            <div class="finished-measurements common-hover">
              {{ $t("newOrder.finishedMeasurements") }}
            </div>
          </div>
          <rMeasurements
            :standardChooseParent="standardChoose"
            @measureInfo="measureInfo"
            @changeSizeId="changeSizeId"
            @changeStandard="changeStandard"
            @changeEditOnce="changeEditOnce"
            :garmentSize="garmentSize"
            :unit="customerDetails"
            :standardList="standardList"
            :sizeTypeId="specBodyParams.sizeType"
            :clothing="clothing"
            :editOnce="editOnce"
          ></rMeasurements>
        </div>
        <div class="step-three-options common-flex common-justify-between">
          <div>
            <Button type="primary" @click="previous"
              >< {{ $t("newOrder.previous") }}</Button
            >
          </div>
          <div>
            <Button @click="submit" style="background: #da8100; color: #fff">
              {{ $t("newOrder.saveCart") }}</Button
            >
            <Button type="primary" @click="submit('order')"
              >{{ $t("newOrder.submit") }}
            </Button>
          </div>
        </div>
      </div>
      <rPreviewImg
        :quickIcon="false"
        :previewShow="previewShow"
        :previewMsg="previewMsg"
        @handlerPreviewShow="handlerPreviewShow"
      ></rPreviewImg>
      <Spin size="large" fix v-if="spinShow"></Spin>
    </div>
  </div>
</template>

<script>
import rPreviewImg from "../../components/r-preview-img";
import rImageChoose from "../../components/r-image-choose";
import rInputBox from "../../components/r-inputbox";
import rIntegration from "../../components/r-integration";
import rDesignCustomer from "../../components/r-design-customer";
import rIpt from "../../components/r-ipt";
import rIptText from "../../components/r-ipt-text";
import rIptSelect from "../../components/r-ipt-select";
import rSelect from "../../components/r-select";
import rDate from "../../components/r-date";
import rInputDate from "../../components/r-input-date";
import rDressStyle from "../../components/r-dress-style";
import rMeasurements from "../../components/r-measurements";
import rOrderChooseCraft from "../../components/r-order-choose-craft";
import rSearchEmb from "../../components/r-search-emb";
import { cmToInch, inchToCom, getBrowserLang, getToken } from "../../libs/util";
import { mapActions } from "vuex";
import { baseUrl } from "@/libs/config";
export default {
  name: "modal",
  components: {
    rInputBox,
    rImageChoose,
    rIntegration,
    rIpt,
    rDesignCustomer,
    rIptSelect,
    rIptText,
    rDressStyle,
    rMeasurements,
    rPreviewImg,
    rOrderChooseCraft,
    rSearchEmb,
    rSelect,
    rDate,
    rInputDate,
  },
  data() {
    return {
      baseUrl: baseUrl,
      uploadHeaders: {
        authorization: getToken(),
        "Accept-Language": getBrowserLang() == "zh" ? "zh" : "en",
      },
      uploadData: {},
      cySizeList: [],
      changeCusNum: 0,
      // 选择的工艺id
      chooseIds: "",
      // 刺绣提示
      enmTips: "",
      // 辅料提示
      accessoriesTips: "",
      // 加载中
      spinShow: false,
      // 是否是编辑初次进入
      editOnce: false,
      bodyList: [], //尺码
      // 提交信息
      submitOrder: {
        custInfo: "",
        fabric: "", //面料编码
        detailList: [
          //订单明细
          {
            clothCategory: 0, //服装分类id
            // craftMap: {
            //工艺信息
            // description: "",
            // },
            craftList: [],
            embList: [
              //刺绣信息
              {
                color: "", //颜色
                embContent: "", //内容
                embSize: "", //绣字大小id
                font: "", //字体id
                site: "", //位置id
                file: "",
              },
            ],
            sizeList: [
              //尺寸信息
              {
                modifyValue: 0, //调整值id
                partId: 0, //尺寸部位id
                partValue: 0, //尺寸值id
              },
            ],
            styleId: 0, //着装风格id
          },
        ],
        bodyTypeList: [], //特体
        addProduct: 0, //追加产品 1是 0否
        amount: 1, //数量
        clothCategory: 0, //服装分类id
        //** 地址信息----------*/
        customerName: "", //客户名称
        shortName: "", //昵称
        genderId: "", //性别
        height: "", //身高
        heightUnit: "", //身高单位
        weight: "", //体重
        weightUnit: "", //体重单位
        phone: "", //手机号
        email: "", //邮箱
        address: "", //地址
        birthdate: "", //birthdate
        customerId: "", //客户id //选择客户时已赋值
        //** 地址信息---------*/
        cusOrderCode: "", //客户单号
        orderId: "", //订单号ID （编辑使用）
        sizeAreaId: "", //号型大类id （亚码 欧码）
        sizeCategoryId: "", //尺寸分类id（净体成衣标准号）
        type: "7", //下单类型 (简单下单，代码下单)
        style: "", //长短款
        memo: "", //订单备注
        remark: "", //备注
        orderInfo: "",
      },
      // 默认选择的工艺
      searchCraftCraftIds: "",
      detailList: {
        clothCategory: 0, //服装分类id
        // craftMap: {
        //工艺信息
        // description: "",
        // },
        craftList: [],
        contrastSaveList: [
          // {
          //   color:'',//颜色id 位置id
          //   site:''
          // }
        ], //撞色信息
        embList: [
          //刺绣信息
          // {
          //   color: "", //颜色
          //   embContent: "", //内容
          //   embSize: "", //绣字大小id
          //   font: "", //字体id
          //   site: "", //位置id
          // },
        ],
        shape: "", //号型
        sizeList: [
          //尺寸信息
          {
            // modifyValue: 0, //调整值id
            // partId: 0, //尺寸部位id
            // partValue: 0, //尺寸值id
          },
        ],
        styleId: "", //着装风格id
      },
      // 显示在左侧的数据
      rightDetails: {
        fabric: {
          name: "",
          url: "",
        },
        detailList: [],
        chooseIndex: 0,
      },
      // **传入字符串 编辑使用
      // 面料列表（需加入json中编辑使用）
      fabricList: [],
      // 当前请求的品类列表等信息（需加入json中编辑使用）
      categroyMsg: "",
      // 选择ctm（需加入json中编辑使用）
      ctmShow: false,
      //order（需加入json中编辑使用）
      params: {
        orderMsg: {
          label: "Order#",
          must: false,
          type: "input",
          inputValue: "",
        },
      },
      // 选择标准号的参数（需加入json中编辑使用）
      standardChoose: {
        property: "", //finished||size  size需要传当前加减值
        id: "", //选择的尺码类型  欧码 亚码
        sizeId: "",
      },
      // 特体信息（需加入json中编辑使用）
      styleList: [],
      //着装风格 （需加入json中编辑使用）
      clothing: [],
      // 是否追加西裤
      isAddShow: false,
      // 长短款列表
      longShort: [],
      garmentSize: [], //成衣尺寸
      // 尺码信息
      sizeList: [],
      // 是否追加西裤列表
      isAddList: [
        {
          id: 1,
          name: this.$t("newOrder.y"),
        },
        {
          id: 0,
          name: this.$t("newOrder.n"),
        },
      ],
      // 选择的特体图片
      chooseStyleMsg: {
        chooseStyleImg: "",
        chooseStyleContent: "",
      },
      // 特体参数
      specBodyParams: {
        sizeType: "",
        category: "",
        customerId: "",
      },

      customerList: [], //客户列表
      customerDetails: "", //客户详情
      searchColor: [],
      searchFont: [],
      searchSize: [],
      searchContrast: [],
      embContent: {
        color: "", //颜色
        colorName: "", //颜色名字
        embContent: "", //内容
        embSize: "", //绣字大小id
        embSizeName: "", //绣字大小名字
        font: "", //字体id
        fontName: "", //字体名字
        site: "", //位置id
      },

      tailoredList: [], // 量体种类

      // 搜索项目
      searchKey: {
        fabric: "",
        color: "",
        font: "",
      },

      // 显示信息
      previewMsg: "",
      // 查询出来的面料
      fabricListSearch: [],
      // 输入的面料
      iptFabric: "",
      // 显示预览modal
      previewShow: false,

      // 基本信息列表
      basicList: [
        {
          label: this.$t("customer.basicList.name"),
          must: true,
          type: "input",
          inputValue: "",
        },
        {
          label: this.$t("customer.basicList.nickname"),
          must: true,
          type: "input",
          inputValue: "",
        },
        {
          label: this.$t("customer.basicList.gender"),
          must: true,
          type: "select",
          value: "",
          list: [],
        },
        {
          label: this.$t("customer.basicList.height"),
          must: true,
          inputValue: "",
          type: "iptSelect",
          value: "",
          list: [],
          iptWidth: 125,
        },
        {
          label: this.$t("customer.basicList.weight"),
          inputValue: "",
          must: true,
          type: "iptSelect",
          value: "",
          list: [],
          iptWidth: 125,
        },

        {
          label: this.$t("customer.basicList.phone"),
          must: false,
          type: "input",
          inputValue: "",
        },
        {
          label: this.$t("customer.basicList.email"),
          must: false,
          type: "input",
          inputValue: "",
        },
        {
          label: this.$t("customer.basicList.address"),
          must: false,
          type: "input",
          inputValue: "",
        },
        {
          label: this.$t("customer.basicList.DOB"),
          must: false,
          type: "date",
          inputValue: "",
        },
      ],
      submitOrderStyle: "",
      // 产品列表
      productList: [],
      replaceCraft: [], //替换工艺
      productId: "",
      //   步骤列表
      stepList: [
        {
          name: this.$t("newOrder.stepName.one"),
          step: 1,
        },
        {
          name: this.$t("newOrder.stepName.two"),
          step: 2,
        },
        {
          name: this.$t("newOrder.stepName.three"),
          step: 3,
        },

        {
          name: this.$t("newOrder.stepName.five"),
          step: 4,
        },
      ],
      //   当前步骤
      stepId: 1,
      // 尺码类型
      standardList: [],
      // 品类列表
      getCategoryList: [],
      // 不需要换算  编辑时一次性使用  跟选择用户时一次性使用
      noChange: false,
      noChangeEdit: false,
      nochangeBzh: false,
      customerInfoShow: false,
    };
  },
  watch: {
    // 监听单位
    "customerDetails.heightUnit": {
      handler(newval, oldval) {
        if (oldval && newval != oldval) {
          if (newval == 10266) {
            //英寸转厘米

            if (this.specBodyParams.sizeType == 10054) {
              this.cmsAll();
            } else {
              this.cms();
            }
          } else if (newval == 10265) {
            //厘米转英寸
            if (this.specBodyParams.sizeType == 10054) {
              this.inchsAll();
            } else {
              this.inchs();
            }
          }
        }
      },
      immediate: true,
      deep: true,
    },
    // 路由监听
    $route: {
      handler() {
        // 如果是编辑
        this.listDictSystem(); //量体方式
        this.zzCraft(this.$route.query.id); //工艺信息
        if (!this.$route.query.orderId) {
          this.zzFabric(this.$route.query.id); //面料信息
        }
        this.specBodyParams.category = this.$route.query.id;
        this.getGenderDictSystem(); //性别
        this.getHeightDictSystem(); //身高单位
        this.getWeightDictSystem(); //体重单位
        this.isAdd(); //是否追加西裤
        this.stepId = 1;
        this.productId = Number(this.$route.query.id);
      },
      deep: true,
      immediate: true,
    },
    // 步骤
    stepId: {
      handler(newval, oldval) {
        if (newval == 3) {
          this.getStyleInfo();
        }
      },
      deep: true,
      immediate: true,
    },
    // 步骤
    submitOrder: {
      handler(newval, oldval) {},
      deep: true,
      immediate: true,
    },
    // 面料监听
    fabricList: {
      handler(newval, oldval) {
        if (newval) {
          let choose = false;
          newval.map((item) => {
            if (item.check) {
              this.rightDetails.fabric.name = item.fabricCode;
              this.rightDetails.fabric.url = item.imagePath;
              choose = true;
            }
          });
          if (!choose) {
            this.rightDetails.fabric.name = "";
            this.rightDetails.fabric.url = "";
          }
        }
      },
      deep: true,
      immediate: true,
    },
    // 输入框输入文字改变 order#
    iptFabric: {
      handler(newval, oldval) {
        this.rightDetails.fabric.name = newval;
        this.rightDetails.fabric.url = "";
      },
      deep: true,
      immediate: true,
    },
    // 右侧显示数据
    rightDetails: {
      handler(newval, oldval) {},
      deep: true,
      immediate: true,
    },
    // 需要显示在右侧的数据有 面料 刺绣 撞色 工艺
    categroyMsg: {
      handler(newval, oldval) {
        // let that = this
        if (newval.length > 0) {
          let craftPriceData = [];
          // 工艺
          newval.map((item, index) => {
            this.rightDetails.detailList[index].craftList = []; //工艺置空
            this.rightDetails.detailList[index].embList = []; //刺绣置空
            this.rightDetails.detailList[index].colorContrast = []; //撞色面料置空
            // 对工艺及辅料进行 显示处理
            // this.chooseIds = "";
            craftPriceData.push({
              category: item.id,
              chooseIds: "",
            });
            if (item.craftList.length > 0) {
              item.craftList.map((allItem) => {
                if (allItem.category == 1 || allItem.category == 3) {
                  if (allItem.children && allItem.children.length > 0) {
                    this.handlecraftId(
                      allItem.children,
                      craftPriceData[craftPriceData.length - 1]
                    );
                    allItem.children.map((childItem) => {
                      if (childItem.isDefault == 1) {
                        //选中
                        // this.chooseIds = this.chooseIds + childItem.id + ",";
                        this.rightDetails.detailList[index].craftList.push({
                          parentName: allItem.name, //父级
                          name: childItem.name, //名字
                          price: childItem.price, //名字
                          url: childItem.craftPath, //所选工艺的图片
                        });
                        if (
                          childItem.children &&
                          childItem.children.length > 0
                        ) {
                          this.setRightCraft(
                            this.rightDetails.detailList[index].craftList,
                            childItem
                          );
                        }
                      }
                      if (
                        childItem.sourceType == "LABEL" &&
                        childItem.children &&
                        childItem.children.length > 0
                      ) {
                        this.setRightCraft(
                          this.rightDetails.detailList[index].craftList,
                          childItem
                        );
                      }
                    });
                  }
                }
              });
            }
            // 处理刺绣结构进行显示
            if (item.emb && item.emb.length > 0) {
              item.emb.map((embitem) => {
                if (embitem.check) {
                  this.rightDetails.detailList[index].embList.push({
                    url: embitem.craftPath, //位置图片
                    name: embitem.name, //位置名称
                    colorName: embitem.embContent.colorName,
                    fontName: embitem.embContent.fontName,
                    embSize: embitem.embContent.embSizeName,
                  });
                }
              });
            }
            // 处理撞色
            if (item.colorContrast && item.colorContrast.length > 0) {
              item.colorContrast.map((contrastitem) => {
                if (contrastitem.check) {
                  this.rightDetails.detailList[index].colorContrast.push({
                    url: contrastitem.craftPath, //位置图片
                    name: contrastitem.name, //位置名称
                    fabric: contrastitem.chooseFabric,
                    fabricCode: contrastitem.chooseFabricCode,
                  });
                }
              });
            }
          });

          this.getCraftPrice(craftPriceData);
        }
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },

    "specBodyParams.sizeType": {
      handler(newval, oldval) {
        if (newval === 10052) {
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    // this.productId = Number(this.$route.query.id);
  },
  beforeRouteUpdate(to, from, next) {
    next();
    location.reload();
  },
  mounted() {
    // baseUrl 已经在 data 中设置
    console.log('newOrder baseUrl:', this.baseUrl);
    
    this.getCust(); //客户
    this.standard(); //尺码类型
    this.isAdd(); //是否追加西裤
    this.dictbasicList(); //长短款列表
    this.getCategory(); //品类
  },
  methods: {
    ...mapActions([
      "zzFabricAction", //面料列
      "zzCraftAction", //工艺
      "zzEmbAction", //刺绣 颜色 字体信息
      "zzContrastAction", //撞色面料
      "searchCraftAction", //搜索工艺
      "specBodyAction", //获得特体信息
      "listDictSystemAction", //获得量体方式
      "getCustAction", //获取用户信息
      "getDictSystemAction", //字典
      "styleInfoAction", //着装风格
      "measureInfoAction", //具体填写尺码信息
      "standardAction", //尺码类型
      "isAddAction", //是否追加西裤
      "dictbasicListAction", //长短款
      "saveOrderAction", //保存订单
      "getFinishedSizeAction", //订单获取成衣尺寸
      "getCategoryAction", //获得品类
      "submitOrderAction", //直接提交订单
      "editOrderAction", //编辑
      "getCraftPriceAction", //获取价格
    ]),

    // 递归获取工艺
    handlecraftId(children, craftItem) {
      children.map((item) => {
        if (item.children && item.children.length > 0) {
          this.handlecraftId(item.children, craftItem);
        } else {
          if (item.isDefault === 1) {
            craftItem.chooseIds += item.id + ",";
            return false;
          }
        }
      });
    },
    // 递归更新价格
    updatePrice(e, pitem) {
      e.children.map((citem) => {
        if (citem.id == pitem.id) {
          if (citem.price != pitem.price) {
            // citem.price = pitem.price||0
            this.$set(citem, "price", pitem.price);
          }
        }
        if (citem.children) {
          this.updatePrice(citem, pitem);
        }
      });
    },
    // 更新价格
    getCraftPrice(data) {
      this.getCraftPriceAction(data).then((res) => {
        // res.data[0].price = '￥900'
        res.data.map((pitem) => {
          this.categroyMsg.map((item) => {
            item.craftList.map((citem) => {
              if (citem.id == pitem.id) {
                if (citem.price != pitem.price) {
                  // citem.price = pitem.price||0
                  this.$set(citem, "price", pitem.price);
                }
              }
              if (citem.children) {
                this.updatePrice(citem, pitem);
              }
            });
          });
        });
      });
    },
    // 默认值赋值
    handSearchCraftCraftIds(citem, item) {
      if (citem.children && citem.children.length > 0) {
        citem.children.map((mitem) => {
          if (mitem.isDefault == 1) {
            if (mitem.children && mitem.children.length > 0) {
              this.handSearchCraftCraftIds(mitem, item);
            } else {
              item.craftChooseList.push(mitem.code);
            }
          }
        });
      } else {
        if (citem.isDefault == 1 && citem.sourceType != "LABEL") {
          item.craftChooseList.push(citem.code);
        }
      }
    },
    // 选中ctm
    chooseCtm(e) {
      this.ctmShow = e;
      if (this.ctmShow) {
        this.fabricList.map((item) => {
          item.check = false;
        });
      }
    },
    // 英寸转厘面
    cms() {
      this.clothing.map((item) => {
        item.sizeList.map((sitem) => {
          if (
            this.specBodyParams.sizeType == 10052 ||
            this.specBodyParams.sizeType == 10053
          ) {
            //如果是净体
            if (!this.noChange) {
              if (sitem.inputValue) {
                sitem.inputValue = Number(
                  inchToCom(sitem.inputValue).toFixed(2)
                );
              }
            } else {
              if (sitem.inputValue) {
                sitem.inputValue = sitem.inputValue;
              }
            }
          }
          if (!this.noChangeEdit) {
            sitem.minValue = Number(inchToCom(sitem.minValue).toFixed(2));
            sitem.maxValue = Number(inchToCom(sitem.maxValue).toFixed(2));
          }
        });
      });
      this.noChange = false;
      this.noChangeEdit = false;
    },
    // 英寸转厘面
    cmsAll() {
      if (!this.nochangeBzh) {
        this.clothing.map((aitem) => {
          aitem.standardList.map((item) => {
            item.details.map((sitem) => {
              sitem.inputValue = Number(inchToCom(sitem.inputValue).toFixed(2));
              sitem.defaultValue = Number(
                inchToCom(sitem.defaultValue).toFixed(2)
              );
              sitem.minValue = Number(inchToCom(sitem.minValue).toFixed(2));
              sitem.maxValue = Number(inchToCom(sitem.maxValue).toFixed(2));
            });
          });
          this.$forceUpdate();
        });
      }
      this.nochangeBzh = false;
    },
    // 厘米转英寸
    inchsAll() {
      if (!this.nochangeBzh) {
        this.clothing.map((aitem) => {
          aitem.standardList.map((item) => {
            item.details.map((sitem) => {
              sitem.defaultValue = Number(
                cmToInch(sitem.defaultValue).toFixed(2)
              );
              sitem.inputValue = Number(cmToInch(sitem.inputValue).toFixed(2));
              sitem.minValue = Number(cmToInch(sitem.minValue).toFixed(2));
              sitem.maxValue = Number(cmToInch(sitem.maxValue).toFixed(2));
            });
          });
          this.$forceUpdate();
        });
      }
      this.nochangeBzh = false;
    },
    // 厘米转英寸
    inchs() {
      this.clothing.map((item) => {
        item.sizeList.map((sitem) => {
          if (
            this.specBodyParams.sizeType == 10052 ||
            this.specBodyParams.sizeType == 10053
          ) {
            //如果是净体
            if (!this.noChange) {
              if (sitem.inputValue) {
                sitem.inputValue = Number(
                  cmToInch(sitem.inputValue).toFixed(2)
                );
              }
            } else {
              if (sitem.inputValue) {
                sitem.inputValue = sitem.inputValue;
              }
            }
          }
          if (!this.noChangeEdit) {
            sitem.minValue = Number(cmToInch(sitem.minValue).toFixed(2));
            sitem.maxValue = Number(cmToInch(sitem.maxValue).toFixed(2));
          }
        });
      });
      this.noChange = false;
      this.noChangeEdit = false;
    },
    // 编辑使用
    changeEditOnce() {
      this.editOnce = false;
    },
    // 修改品类
    changeProduct(e) {
      this.$router.replace({
        name: "newOrder",
        query: {
          id: e,
        },
      });
      this.getCust(); //客户
      this.standard(); //尺码类型
      this.isAdd(); //是否追加西裤
      this.dictbasicList(); //长短款列表
      this.getCategory(); //品类
    },
    // 获得编辑数据
    editOrder() {
      // this.changeCusNum++
      this.editOrderAction({
        orderId: this.$route.query.orderId,
        type:
          this.$route.query.orderType &&
          this.$route.query.orderType === "buyagain"
            ? "buy"
            : "edit",
      }).then((res) => {
        let orderInfo = JSON.parse(res.data.orderInfo);
        this.$set(this, "fabricList", orderInfo.fabricList);
        this.$set(this, "categroyMsg", orderInfo.categroyMsg);
        this.$set(this, "params", orderInfo.params);
        this.$set(this, "standardChoose", orderInfo.standardChoose);
        this.$set(this, "styleList", orderInfo.styleList);
        this.$set(this, "clothing", orderInfo.clothing);
        this.$set(this, "isAddShow", orderInfo.isAddShow);
        this.$set(this, "basicList", orderInfo.basicList);
        let hasFabric = this.fabricList.some((fItem) => {
          return fItem.check === true;
        });
        if (!hasFabric) {
          this.iptFabric = res.data.fabric;
          this.ctmShow = true;
        }
        this.categroyMsg.map((item) => {
          // 工艺辅料重新赋值  浅克隆 可联动
          item.craft = [];
          item.accessories = [];
          item.craftList.map((citem) => {
            if (citem.category == 1) {
              item.craft.push(citem);
            } else if (citem.category == 3) {
              item.accessories.push(citem);
            }
          });
        });
        this.clothing.map((cloitem) => {
          cloitem.standardList.map((sloitem) => {
            if (cloitem.chosoeId == sloitem.id) {
              this.$set(cloitem, "sizeList", sloitem.details);
            }
          });
        });
        for (let key in res.data) {
          if (
            key == "style" ||
            key == "addProduct" ||
            key == "sizeCategoryId"
          ) {
            this.$set(this.submitOrder, key, Number(res.data[key]));
            if (key == "sizeCategoryId") {
              this.$set(this.specBodyParams, "sizeType", Number(res.data[key]));
            }
          } else {
            this.$set(this.submitOrder, key, res.data[key]);
          }
        }
        // rMeasurements组件 终止第一次触发获取 标准号尺码事件
        if (
          this.$route.query.orderId &&
          this.submitOrder.sizeCategoryId == 10054
        ) {
          this.editOnce = true;
        } else {
          this.editOnce = false;
        }
        this.customerDetails = {
          heightUnitName: res.data.heightUnitName,
          heightUnit: res.data.heightUnit,
        };
      });
    },
    // 获得品类
    getCategory() {
      this.getCategoryAction({ orderWay: 7 }).then((res) => {
        this.getCategoryList = res.data;
      });
    },
    // 图片报错置空
    imgError(e) {
      e.url = "";
    },
    changeChooseIndex(e) {
      this.rightDetails.chooseIndex = e;
    },
    // 切换右侧显示index
    changeJeans(e) {
      this.rightDetails.chooseIndex = e;
      if (this.stepId == 1) {
        let idName = "#cloth" + e;
        this.$el.querySelector(idName).scrollIntoView({
          behavior: "smooth", // 平滑过渡
          block: "start", // 上边框与视窗顶部平齐。默认值
        });
      } else if (this.stepId == 2) {
        let idName = "#cloths" + e;
        this.$el.querySelector(idName).scrollIntoView({
          behavior: "smooth", // 平滑过渡
          block: "start", // 上边框与视窗顶部平齐。默认值
        });
      }
    },
    // 长短款
    dictbasicList() {
      this.dictbasicListAction({
        category: 41,
      }).then((res) => {
        this.longShort = res.data;
        if (this.submitOrder.style == "") {
          this.submitOrder.style = res.data[0].id;
        }
      });
    },
    // 是否追加西裤
    isAdd() {
      this.isAddAction({ category: this.$route.query.id }).then((res) => {
        this.isAddShow = res.data;
      });
    },
    // 选尺码类型
    changeStandard(e) {
      this.standardChoose = e;
    },
    // 选号型
    changeSizeId(e) {
      this.standardChoose = e;
      this.measureInfo(this.standardChoose.sizeId);
    },
    // 尺码类型
    standard() {
      this.standardAction({
        category: this.$route.query.id,
      }).then((res) => {
        this.standardList = res.data;
      });
    },
    // 修改特体
    changeStyle(item, litem) {
      item.chooseId = litem.id;
      this.chooseStyleMsg.chooseStyleImg = litem.imagePath;
      this.chooseStyleMsg.chooseStyleContent = litem.description;
    },
    // 着装风格
    getStyleInfo() {
      this.styleInfoAction({
        category: this.$route.query.id,
      }).then((res) => {
        res.data.map((item) => {
          this.clothing.map((citem) => {
            if (citem.chooseStyleId == "") {
              citem.chooseStyleId = item.styleList[0].id;
            }
            if (item.id == citem.id) {
              citem.styleList = item.styleList;
            }
          });
        });
        // this.clothing = res.data
      });
    },
    // 性别
    getGenderDictSystem() {
      this.getDictSystemAction({ category: 10 }).then((res) => {
        res.data.map((item) => {
          item.label = item.name;
          item.value = item.id;
        });
        if (this.$route.query.orderId == undefined) {
          this.basicList[2].value = res.data[0].id;
        }
        this.basicList[2].list = res.data;
      });
    },

    // 体重
    getWeightDictSystem() {
      this.getDictSystemAction({ category: 29 }).then((res) => {
        res.data.map((item) => {
          item.label = item.name;
          item.value = item.id;
        });
        if (this.$route.query.orderId == undefined) {
          this.basicList[4].value = res.data[0].id;
        }
        this.basicList[4].list = res.data;
      });
    },
    // 身高
    getHeightDictSystem() {
      this.getDictSystemAction({ category: 30 }).then((res) => {
        res.data.map((item) => {
          item.label = item.name;
          item.value = item.id;
          // if (getBrowserLang() == "zh") {
          //中文默认厘米10266  其余为英寸 10265
          if (item.id == 10266) {
            if (this.$route.query.orderId == undefined) {
              this.basicList[3].value = item.id;
              this.customerDetails = {
                heightUnitName: item.name,
                heightUnit: item.id,
              };
            }
          }
          // }
          // else {
          //   if (item.id == 10265) {
          //     if (this.$route.query.orderId == undefined) {
          //       this.basicList[3].value = item.id;
          //       this.customerDetails = {
          //         heightUnitName: item.name,
          //         heightUnit: item.id,
          //       };
          //     }
          //   }
          // }
        });

        this.basicList[3].list = res.data;
      });
    },
    // 选择客户
    chooseCustomer(e) {
      this.bodyList = e.customerSizeList;
      this.cySizeList = e.cySizeList;
      // this.bodyList = custInfo.bodyList;
      if (e.customerSpecialList.length > 0) {
        this.styleList.map((item) => {
          e.customerSpecialList.map((citem) => {
            if (citem.desId == item.id) {
              item.chooseId = citem.specId;
            }
          });
        });
      } else {
        this.styleList.map((item) => {
          item.chooseId = item.details[0].id;
        });
      }
      if (
        this.specBodyParams.sizeType == 10053 &&
        this.cySizeList &&
        this.cySizeList.length > 0
      ) {
        this.clothing.map((item) => {
          this.cySizeList.map((cyitem) => {
            if (item.id == cyitem.clothId) {
              item.sizeList.map((sitem) => {
                this.$set(sitem, "inputValue", "");
                cyitem.partList.map((cypitem) => {
                  if (cypitem.partId == sitem.id) {
                    if (cypitem.partSize) {
                      this.$set(sitem, "inputValue", cypitem.partSize);
                    }
                    // if (this.customerDetails.heightUnit == 10266) {
                    // } else {
                    //   if (cypitem.partSize) {
                    //     sitem.inputValue = cmToInch(cypitem.partSize).toFixed(
                    //       2
                    //     );
                    //   } else {
                    //     sitem.inputValue = "";
                    //   }
                    // }
                    // sitem.inputValue = cypitem.partSize
                  }
                });
              });
            }
          });
        });
      } else {
        if (this.specBodyParams.sizeType !== 10054) {
          this.clothing.map((item) => {
            item.sizeList.map((sitem) => {
              this.$set(sitem, "inputValue", "");
            });
          });
        }
      }

      if(  this.specBodyParams.sizeType != 10054){
      if (
        e.customerSizeList.length > 0
      ) {
        if (
          this.specBodyParams.sizeType == 10052 ||
          this.specBodyParams.sizeType == 10054
        ) {
          this.clothing.map((item) => {
            item.sizeList.map((sitem) => {
              this.$set(sitem, "inputValue", "");
              this.bodyList.map((bitem) => {
                if (bitem.partId == sitem.id && bitem.partSize) {
                  sitem.inputValue = bitem.partSize;
                }
              });
            });
          });
        }
      } else {
        this.clothing.map((item) => {
          item.sizeList.map((sitem) => {
            sitem.inputValue = "";
          });
        });
      }
      }
      this.basicList[0].inputValue = e.custName;
      this.basicList[1].inputValue = e.shortName;
      this.basicList[2].value = e.genderId;
      this.basicList[3].inputValue = e.height;
      this.basicList[3].value = e.heightUnit;
      this.basicList[4].inputValue = e.weight;
      this.basicList[4].value = e.weightUnit;
      this.basicList[5].inputValue = e.phone;
      this.basicList[6].inputValue = e.email;
      this.basicList[7].inputValue = e.address;
      this.basicList[8].inputValue = e.birthdate;
      this.submitOrder.customerId = e.id;
      this.submitOrder.customerName = e.custName;
      this.customerDetails = e;
      this.changeCusNum++;
      if (
        this.changeCusNum == 1 &&
        e.heightUnit == 10266 &&
        this.specBodyParams.sizeType != 10053
      ) {
        this.noChange = false;
      } else {
        this.noChange = true;
      }
    },
    // 获取用户信息
    getCust() {
      this.getCustAction({ keywords: "" }).then((res) => {
        this.customerList = res.data;
        this.customerInfoShow = true;
      });
    },
    changeIptSelect(e) {
      if (e == 3) {
        this.basicList[3].list.map((item) => {
          if (item.value == this.basicList[3].value) {
            this.customerDetails.heightUnitName = item.label;
            this.customerDetails.heightUnit = item.id;
          }
        });
      }
    },
    // 修改量体方式
    changeTailored(e) {
      if (e === 10052 || e === 10053) {
        this.measureInfo("");
      } else {
        this.clothing.map((citem) => {
          citem.sizeList = [];
          // citem.standardList = []
        });
      }
      this.specBodyParams.sizeType = e;
      this.standardChoose.id = this.standardList[0].id;
      this.standardChoose.property = this.standardList[0].property;
      this.specBody(); //特体信息
      // this.handleHasExtension()
    },
    // 特提信息
    specBody() {
      this.specBodyAction(this.specBodyParams).then((res) => {
        if (res.data) {
          res.data.map((item) => {
            item.chooseId = "";
          });
          this.styleList = res.data;
          this.styleList.map((item) => {
            if (item.chooseId) return false;
            let normalItem = item.details.find(
              (dItem, dIIndex) => dIIndex === 0
            );
            this.$set(item, "chooseId", normalItem.id);
          });
          this.chooseStyleMsg = {
            chooseStyleImg: "",
            chooseStyleContent: "",
          };
        } else {
          this.styleList = [];
          this.chooseStyleMsg = {
            chooseStyleImg: "",
            chooseStyleContent: "",
          };
        }
      });
    },
    // 获取填写的尺寸信息
    measureInfo(shapeCategory) {
      this.measureInfoAction({
        category: this.$route.query.id,
        measureType: this.specBodyParams.sizeType,
        shapeCategory: shapeCategory,
        customerId:
          this.specBodyParams.sizeType === 10054
            ? ""
            : this.submitOrder.customerId,
      }).then((res) => {
        res.data.map((item) => {
          this.clothing.map((citem) => {
            if (item.id == citem.id) {
              if (this.specBodyParams.sizeType == 10054) {
                citem.standardList = item.sizeList;
                citem.sizeList = item.sizeList[0].details;
                citem.chosoeId = item.sizeList[0].id;
                item.sizeList.map((aitem) => {
                  if (this.customerDetails.heightUnit == 10266) {
                    aitem.details.map((ditem) => {
                      ditem.inputValue = JSON.parse(
                        JSON.stringify(ditem.defaultValue)
                      );
                      ditem.addNum = 0.5;
                    });
                  } else {
                    aitem.details.map((ditem) => {
                      ditem.minValue = Number(
                        cmToInch(ditem.minValue).toFixed(2)
                      );
                      ditem.maxValue = Number(
                        cmToInch(ditem.maxValue).toFixed(2)
                      );
                      if (ditem.defaultValue != undefined) {
                        ditem.defaultValue = cmToInch(
                          ditem.defaultValue
                        ).toFixed(2);
                      }
                      ditem.inputValue = JSON.parse(
                        JSON.stringify(ditem.defaultValue)
                      );
                      ditem.addNum = 0.5;
                    });
                  }
                });
              } else {
                citem.standardList = [];
                // 尺寸换算
                item.sizeList.map((sitem) => {
                  if (this.customerDetails.heightUnit == 10266) {
                    // 单位是厘米
                    if (item.sizeUnit === 10266) {
                      sitem.inputValue = sitem.inputValue;
                    } else {
                      if (sitem.inputValue != undefined) {
                        sitem.inputValue = inchToCom(sitem.inputValue).toFixed(
                          2
                        );
                      }
                    }
                    // 单位是英寸
                  } else {
                    sitem.minValue = Number(
                      cmToInch(sitem.minValue).toFixed(2)
                    );
                    sitem.maxValue = Number(
                      cmToInch(sitem.maxValue).toFixed(2)
                    );

                    if (item.sizeUnit === 10266) {
                      if (sitem.inputValue != undefined) {
                        sitem.inputValue = cmToInch(sitem.inputValue).toFixed(
                          2
                        );
                      }
                    }
                  }
                });
                citem.sizeList = item.sizeList;
              }
            }
          });

          // if (
          //   this.specBodyParams.sizeType == 10052 &&
          //   this.bodyList.length > 0
          // ) {
          //   this.clothing.map((item) => {
          //     item.sizeList.map((sitem) => {
          //       this.bodyList.map((bitem) => {
          //         if (bitem.partId == sitem.id) {
          //           if (this.customerDetails.heightUnit == 10266) {
          //             if (bitem.partSize) {
          //               this.$set(sitem, "inputValue", bitem.partSize);
          //             } else {
          //               this.$set(sitem, "inputValue", "");
          //             }
          //           } else {
          //             if (bitem.partSize) {
          //               sitem.inputValue = cmToInch(bitem.partSize).toFixed(2);
          //             } else {
          //               sitem.inputValue = "";
          //             }
          //           }
          //         }
          //       });
          //     });
          //   });
          // }
          // // if(this.clothing.id==)
          // if (
          //   this.specBodyParams.sizeType == 10053 &&
          //   this.cySizeList.length > 0
          // ) {
          //   this.clothing.map((item) => {
          //     this.cySizeList.map((cyitem) => {
          //       if (item.id == cyitem.clothId) {
          //         cyitem.partList.map((cypitem) => {
          //           item.sizeList.map((sitem) => {
          //             if (cypitem.partId == sitem.id) {
          //               if (this.customerDetails.heightUnit == 10266) {
          //                 this.$set(sitem, "inputValue", cypitem.partSize);
          //               } else {
          //                 if (cypitem.partSize) {
          //                   sitem.inputValue = cmToInch(
          //                     cypitem.partSize
          //                   ).toFixed(2);
          //                 } else {
          //                   sitem.inputValue = "";
          //                 }
          //               }
          //               // sitem.inputValue = cypitem.partSize
          //             }
          //           });
          //         });
          //       }
          //     });
          //   });
          // }
        });
        this.handleHasExtension();
      });
    },
    checksPreventDefault(e) {
      e.preventDefault();
    },
    // 获得量体方式
    listDictSystem() {
      this.listDictSystemAction({
        category: 13,
      }).then((res) => {
        this.tailoredList = res.data;
      });
    },
    // 搜索工艺 赋值替换原工艺
    searchCraft(e) {
      // 如果不存在列表
      if (e.length == 0) {
        return;
      }
      let params = {
        category: e[0].split("_")[0],
        craftIds: "",
      };
      // 使用切换时的默认值
      e.map((item) => {
        item.split("_").map((citem, cindex) => {
          if (cindex > 0) {
            if (citem) {
              params.craftIds = params.craftIds + citem + ",";
            }
          }
        });
      });
      let arrFrom = Array.from(new Set(params.craftIds.split(",")));
      params.craftIds = arrFrom.join(",");
      let changeList = [];
      let changeChildIdsList = [];
      this.searchCraftAction(params).then((res) => {
        this.replaceCraft = res.data;
        if (res.data.length > 0) {
          res.data.map((item) => {
            if (item.children && item.children.length > 0) {
              this.setParentIds(item);
            }
            changeList.push(item.code);
            changeChildIdsList.push(item.childIds);
            // 避免默认赋值不显示
            let change = true;
            let children = JSON.parse(JSON.stringify(item.children));
            for (let i = 0; i < item.children.length; i++) {
              if (
                params.craftIds
                  .split(",")
                  .indexOf(item.children[i].id.toString()) > -1
              ) {
                this.$set(item.children[i], "isDefault", 1);
                change = false;
              } else {
                this.$set(item.children[i], "isDefault", 0);
              }
            }
            if (change) {
              item.children = JSON.parse(JSON.stringify(children));
            }
          });
        }
        this.categroyMsg.map((item) => {
          item.craft.map((citem) => {
            // 检查当前选中列表是否存在下级
            if (changeList.indexOf(citem.code) != -1) {
              if (changeChildIdsList.indexOf(citem.childIds) == -1) {
                /*替换*/
                if (!citem.copyChildren || citem.copyChildren.length == 0) {
                  citem.children.map((pitem) => {
                    pitem.isDefault = 0;
                  });
                  citem.copyChildren = JSON.parse(
                    JSON.stringify(citem.children)
                  );
                }
                citem.childIds =
                  this.replaceCraft[changeList.indexOf(citem.code)].childIds;
                citem.children =
                  this.replaceCraft[changeList.indexOf(citem.code)].children;
                /*替换之前查看是否有已选中属性 置空*/
                this.craftSelectSpliceCopy(citem);
              }
            } else {
              if (citem.copyChildren && citem.copyChildren.length > 0) {
                citem.children = JSON.parse(JSON.stringify(citem.copyChildren));
              }
              citem.copyChildren = [];
            }
            if (citem.children && citem.children.length > 0) {
              this.replaceChildren(
                citem.children,
                changeList,
                changeChildIdsList
              );
            }
          });
        });
      });
    },
    // 替换
    replaceChildren(children, changeList, changeChildIdsList) {
      children.map((citem) => {
        if (changeList.indexOf(citem.code) != -1) {
          if (changeChildIdsList.indexOf(citem.childIds) == -1) {
            /*替换*/
            if (!citem.copyChildren || citem.copyChildren.length == 0) {
              citem.children.map((pitem) => {
                pitem.isDefault = 0;
              });
              citem.copyChildren = JSON.parse(JSON.stringify(citem.children));
            }
            citem.childIds =
              this.replaceCraft[changeList.indexOf(citem.code)].childIds;
            citem.children =
              this.replaceCraft[changeList.indexOf(citem.code)].children;
            this.craftSelectSpliceCopy(citem, changeList);
          }
        } else {
          if (citem.copyChildren && citem.copyChildren.length > 0) {
            citem.children = JSON.parse(JSON.stringify(citem.copyChildren));
          }
          citem.childIds = "";
          citem.copyChildren = [];
        }
        if (citem.children && citem.children.length > 0) {
          this.replaceChildren(citem.children, changeList, changeChildIdsList);
        }
      });
    },
    handleChildExtension(children, middleObj) {
      children.map((item) => {
        if (item.children && item.children.length > 0) {
          this.handleChildExtension(item.children, middleObj);
        } else {
          if (item.isDefault === 1 && item.extension) {
            middleObj.hasxtension = true;
            this.handleReviseSzieList(item);
          }
        }
      });
    },
    handleResetDisabled() {
      if (this.specBodyParams.sizeType !== 10054) {
        this.clothing.map((item) => {
          item.sizeList.map((sitem) => {
            this.$set(sitem, "disabled", false);
          });
        });
      } else {
        this.clothing.map((item) => {
          item.standardList.map((sitem) => {
            sitem.details.map((ditem) => {
              this.$set(ditem, "disabled", false);
            });
          });
        });
      }
    },
    // 判断当前品类的工艺是否存在长短袖
    handleHasExtension() {
      let middleObj = {
        hasxtension: false,
      };
      this.categroyMsg.map((item) => {
        item.craftList.map((citem) => {
          if (citem.children && citem.children.length > 0) {
            this.handleChildExtension(citem.children, middleObj);
          }
        });
      });
      if (!middleObj.hasxtension) {
        this.categroyMsg.map((item) => {
          item.craftList.map((citem) => {
            if (citem.children && citem.children.length > 0) {
              this.handleResetDisabled();
            }
          });
        });
      }
    },
    // 长短袖
    handleReviseSzieList(craftData) {
      let showSize = null;
      let hideSize = null;
      let categoryCode = craftData.code.split("_")[0];
      if (!craftData.extension) {
        return false;
      }
      let sizes = craftData.extension.split("|");
      // 净体
      if (this.specBodyParams.sizeType === 10052) {
        showSize = sizes[0].split("&")[0] || "";
        hideSize = sizes[0].split("&")[1] || "";
        // 成衣
      } else if (this.specBodyParams.sizeType !== 10052) {
        showSize = sizes[1].split("&")[0];
        hideSize = sizes[1].split("&")[1];
      }
      if (this.specBodyParams.sizeType !== 10054) {
        let currentItem = this.clothing.find((item) => {
          return item.id === Number(categoryCode);
        });
        currentItem.sizeList.map((item) => {
          this.$set(item, "disabled", false);
          let hasSize = hideSize.includes(item.id);
          if (hasSize) {
            this.$set(item, "disabled", true);
          }
        });
      } else {
        let currentSize = this.clothing.find((item) => {
          return item.id === Number(categoryCode);
        });
        currentSize.standardList.find((item) => {
          item.details.map((ditem) => {
            this.$set(ditem, "disabled", false);
            let hasSize = hideSize.includes(ditem.id);
            if (hasSize) {
              this.$set(ditem, "disabled", true);
            }
          });
        });
      }
    },
    // 每次点击面料的选项
    craftSelect(e, config) {
      console.log('craftSelect',123,e, config)
      // 将当前级别跟下级一块填充
      let changesMsg = "";
      this.categroyMsg.map((item, index) => {
        if (item.id == config.code.split("_")[0]) {
          changesMsg = item;
        }
      });
      if (e.isDefault == 1) {
        changesMsg.craftChooseList.push(e.code);
        if (e.children && e.children.length > 0) {
          e.children.map((citem) => {
            if (citem.isDefault == 1) {
              this.craftSelect(citem, config);
            }
          });
        }
        config.children.map((ccitem, ccindex) => {
          if (
            changesMsg.craftChooseList.indexOf(ccitem.code) != -1 &&
            ccitem.isDefault == 0
          ) {
            changesMsg.craftChooseList.splice(
              changesMsg.craftChooseList.indexOf(ccitem.code),
              1
            );
            if (ccitem.children && ccitem.children.length > 0) {
              this.craftSelectSplice(ccitem, changesMsg);
            }
          }
        });
      } else if (e.isDefault == 0) {
        let index = changesMsg.craftChooseList.indexOf(e.code);
        changesMsg.craftChooseList.splice(index, 1);
        if (e.children && e.children.length > 0) {
          e.children.map((citem) => {
            if (citem.isDefault == 1) {
              this.craftSelectSplice(citem, changesMsg);
            }
          });
        }
      }
      console.log('changesMsg',changesMsg)
      this.searchCraft(changesMsg.craftChooseList);
      this.handleHasExtension(e);
    },
    craftSelectSplice(e, changesMsg) {
      e.children.map((ccitem) => {
        if (
          changesMsg.craftChooseList.indexOf(ccitem.code) != -1 &&
          ccitem.isDefault == 0
        ) {
          changesMsg.craftChooseList.splice(
            changesMsg.craftChooseList.indexOf(ccitem.code),
            1
          );
          if (ccitem.children && ccitem.children.length > 0) {
            this.craftSelectSplice(ccitem, changesMsg);
          }
        }
      });
    },
    craftSelectSpliceCopy(e) {
      this.categroyMsg.map((item) => {
        if (item.id == e.code.split("_")[0]) {
          let changesMsg = "";
          changesMsg = item;
          e.copyChildren.map((ccitem) => {
            if (
              changesMsg.craftChooseList.indexOf(ccitem.code) != -1 &&
              ccitem.isDefault == 0
            ) {
              changesMsg.craftChooseList.splice(
                changesMsg.craftChooseList.indexOf(ccitem.code),
                1
              );
              // 暂时不考虑无限下级情况
              // if (ccitem.children && ccitem.children.length > 0) {
              //   this.craftSelectSpliceCopy(ccitem, changesMsg);
              // }
            }
          });
        }
      });
    },

    // 搜索颜色
    queryChangeColor(e, parent) {
      this.zzEmbAction({
        category: parent.code.split("_")[0],
        type: "emb_color",
        keywords: e,
      }).then((res) => {
        res.data.map((item) => {
          item.isDefault = 0;
        });
        this.searchColor = res.data;
      });
    },
    // 修改选中颜色
    changeColor(e, parent) {
      let isExistence = false;
      let notExistence = "";
      parent.embColor.forEach((item) => {
        if (item.id == e) {
          isExistence = true;
        }
      });
      // 输入的面料置空
      if (e) {
        //选择了列表数据
        if (isExistence) {
          //在原列表存在
          parent.embColor.map((item, index) => {
            if (item.id == e) {
              item.isDefault = 1;
            } else {
              item.isDefault = 0;
            }
            let msg = JSON.parse(JSON.stringify(item));
            parent.embColor.splice(index, 1, msg);
            parent.embContent.color = msg.id;
            parent.embContent.colorName = msg.name;
            this.$forceUpdate();
          });
        } else {
          this.searchColor.forEach((item, index) => {
            if (item.id == e) {
              item.isDefault = 1;
              notExistence = item;
            }
          });
          parent.embColor.map((item, index) => {
            item.isDefault = 0;
            let msg = JSON.parse(JSON.stringify(item));
            parent.embColor.splice(index, 1, msg);
          });
          parent.embColor.unshift(notExistence);
          parent.embContent.color = notExistence.id;
          parent.embContent.colorName = notExistence.name;
          this.$forceUpdate();
        }
      }
    },
    // 选中颜色
    colorSelect(e, item, parent) {
      parent.embColor.map((citem, cindex) => {
        if (e == cindex) {
          citem.isDefault = 1;
          parent.embContent.color = citem.id;
          parent.embContent.colorName = citem.name;
        } else {
          citem.isDefault = 0;
        }
        let details = JSON.parse(JSON.stringify(citem));
        parent.embColor.splice(cindex, 1, details);
      });
      this.$forceUpdate();
    },
    // 搜索尺寸
    queryChangeSize(e, parent) {
      this.zzEmbAction({
        category: parent.code.split("_")[0],
        type: "emb_size",
        keywords: e,
      }).then((res) => {
        res.data.map((item) => {
          item.isDefault = 0;
        });
        this.searchSize = res.data;
      });
    },
    // 修改选中尺寸
    changeSize(e, parent) {
      let isExistence = false;
      let notExistence = "";
      parent.embSize.forEach((item) => {
        if (item.id == e) {
          isExistence = true;
        }
      });
      // 输入的面料置空
      if (e) {
        //选择了列表数据
        if (isExistence) {
          //在原列表存在
          parent.embSize.map((item, index) => {
            if (item.id == e) {
              item.isDefault = 1;
            } else {
              item.isDefault = 0;
            }
            let msg = JSON.parse(JSON.stringify(item));
            parent.embSize.splice(index, 1, msg);
            parent.embContent.embSize = msg.id;
            parent.embContent.embSizeName = msg.name;
            this.$forceUpdate();
          });
        } else {
          this.searchSize.forEach((item, index) => {
            if (item.id == e) {
              item.isDefault = 1;
              notExistence = item;
            }
          });
          parent.embSize.map((item, index) => {
            item.isDefault = 0;
            let msg = JSON.parse(JSON.stringify(item));
            parent.embSize.splice(index, 1, msg);
          });
          parent.embSize.unshift(notExistence);
          parent.embContent.embSize = notExistence.id;
          parent.embContent.embSizeName = notExistence.name;
          this.$forceUpdate();
        }
      }
    },
    // 选中尺寸
    sizeSelect(e, item, parent) {
      parent.embSize.map((citem, cindex) => {
        if (e == cindex) {
          citem.isDefault = 1;
          parent.embContent.embSize = citem.id;
          parent.embContent.embSizeName = citem.name;
        } else {
          citem.isDefault = 0;
        }
        let details = JSON.parse(JSON.stringify(citem));
        parent.embSize.splice(cindex, 1, details);
      });
      this.$forceUpdate();
    },
    // 搜索字体
    queryChangeFont(e, parent) {
      this.zzEmbAction({
        category: parent.code.split("_")[0],
        type: "emb_font",
        keywords: e,
      }).then((res) => {
        res.data.map((item) => {
          item.isDefault = 0;
        });
        this.searchFont = res.data;
      });
    },

    // 修改选中字体
    changeFont(e, parent) {
      let isExistence = false;
      let notExistence = "";
      parent.embFont.forEach((item) => {
        if (item.id == e) {
          isExistence = true;
        }
      });
      // 输入的面料置空
      if (e) {
        //选择了列表数据
        if (isExistence) {
          //在原列表存在
          parent.embFont.map((item, index) => {
            if (item.id == e) {
              item.isDefault = 1;
            } else {
              item.isDefault = 0;
            }
            let msg = JSON.parse(JSON.stringify(item));
            parent.embFont.splice(index, 1, msg);
            parent.embContent.font = msg.id;
            parent.embContent.fontName = msg.name;
            this.$forceUpdate();
          });
        } else {
          this.searchFont.forEach((item, index) => {
            if (item.id == e) {
              item.isDefault = 1;
              notExistence = item;
            }
          });
          parent.embFont.map((item, index) => {
            item.isDefault = 0;
            let msg = JSON.parse(JSON.stringify(item));
            parent.embFont.splice(index, 1, msg);
          });
          parent.embFont.unshift(notExistence);
          parent.embContent.font = notExistence.id;
          parent.embContent.fontName = notExistence.name;
          this.$forceUpdate();
        }
      }
    },
    // 选中字体
    fontSelect(e, item, parent) {
      if (item.extension === "file") {
        this.$set(parent, "currentExtension", "file");
      } else {
        this.$set(parent, "currentExtension", "");
      }
      parent.embFont.map((citem, cindex) => {
        if (e == cindex) {
          citem.isDefault = 1;
          parent.embContent.font = citem.id;
          parent.embContent.fontName = citem.name;
        } else {
          citem.isDefault = 0;
        }
        let details = JSON.parse(JSON.stringify(citem));
        parent.embFont.splice(cindex, 1, details);
      });
      this.$forceUpdate();
    },
    // 搜索撞色面料
    queryChangeContrast(e, parent) {
      this.zzContrastAction({
        category: parent.code.split("_")[0],
        keywords: e,
      }).then((res) => {
        res.data.map((item) => {
          item.isDefault = 0;
        });
        this.searchContrast = res.data;
      });
    },
    // 修改撞色面料
    changeContrast(e, parent) {
      let isExistence = false;
      let notExistence = "";
      parent.colorContrastFabric.forEach((item) => {
        if (item.id == e) {
          isExistence = true;
        }
      });
      // 输入的面料置空
      if (e) {
        //选择了列表数据
        if (isExistence) {
          //在原列表存在
          parent.colorContrastFabric.map((item, index) => {
            if (item.id == e) {
              item.isDefault = 1;
            } else {
              item.isDefault = 0;
            }
            let msg = JSON.parse(JSON.stringify(item));
            parent.colorContrastFabric.splice(index, 1, msg);
            this.$forceUpdate();
          });
        } else {
          this.searchContrast.forEach((item, index) => {
            if (item.id == e) {
              item.isDefault = 1;
              notExistence = item;
            }
          });
          parent.colorContrastFabric.map((item, index) => {
            item.isDefault = 0;
            let msg = JSON.parse(JSON.stringify(item));
            parent.colorContrastFabric.splice(index, 1, msg);
          });
          parent.colorContrastFabric.unshift(notExistence);
          this.$forceUpdate();
        }
      }
    },
    // 选中面料
    contrastSelect(e, item, parent) {
      parent.colorContrastFabric.map((citem, cindex) => {
        if (e == cindex) {
          citem.isDefault = 1;
          parent.chooseFabric = citem.id;
          parent.chooseFabricCode = citem.name;
        } else {
          citem.isDefault = 0;
        }
        let details = JSON.parse(JSON.stringify(citem));
        parent.colorContrastFabric.splice(cindex, 1, details);
      });
      this.$forceUpdate();
    },
    // 搜索词改变时触发
    queryChangeFabri(e) {
      this.zzFabricAction({
        clothCategory: this.$route.query.id,
        keywords: e,
      }).then((res) => {
        this.fabricListSearch = res.data;
      });
    },
    // 显示预览图
    previewImg(e) {
      this.previewShow = true;
      this.previewMsg = e;
    },
    // 隐藏预览
    handlerPreviewShow() {
      this.previewShow = false;
    },
    // 填写面料聚焦
    fabricFocus() {
      this.fabricList.map((item) => {
        item.check = false;
      });
    },
    // 面料
    iptValue(e) {
      this.iptFabric = e;
    },
    // 选取面料
    changeFabri(e) {
      let isExistence = false;
      let notExistence = "";
      this.fabricList.forEach((item) => {
        if (item.id == e) {
          isExistence = true;
        }
      });
      // 输入的面料置空
      if (e) {
        //选择了列表数据
        if (isExistence) {
          //面料在原列表存在
          this.iptFabric = "";
          let fabricList = JSON.parse(JSON.stringify(this.fabricList));
          let chooseIndex = "";
          let chooseItem = "";
          // 将原有位置的删除 并将选中的前置
          fabricList.map((item, index) => {
            if (e == item.id) {
              chooseIndex = index;
              // item.check = true;
              this.$set(item, "check", true);
              chooseItem = item;
            }
          });
          this.fabricList.splice(chooseIndex, 1);
          this.fabricList.unshift(chooseItem);
          this.fabricList.map((item, index) => {
            if (index > 0) {
              // item.check = false;
              this.$set(item, "check", false);
            }
          });
        } else {
          this.fabricList.map((item, index) => {
            this.$set(item, "check", false);
          });
          this.fabricListSearch.forEach((item) => {
            if (item.id == e) {
              this.$set(item, "check", true);
              notExistence = item;
            }
          });
          this.fabricList.splice(0, 1, notExistence);
        }
      }
    },
    // 获得面料列表
    zzFabric(e) {
      this.zzFabricAction({ clothCategory: e }).then((res) => {
        res.data.map((item) => {
          item.check = false;
        });
        this.fabricList = res.data;
      });
    },
    // 获得工艺
    zzCraft(e) {
      this.zzCraftAction({ category: e }).then((res) => {
        this.clothing = [];
        this.rightDetails.detailList = [];
        if (res.data.length == 0) {
          return;
        }
        res.data.map((item, cloindex) => {
          // 第三步数据赋值
          this.clothing.push({
            id: item.id,
            enName: item.enName,
            name: item.name,
            // styleId: "",
            chooseStyleId: "",
            sizeList: [],
            standardList: [],
            styleList: [],
          });
          this.rightDetails.detailList.push({
            clothCategory: item.id,
            url: item.urlPath,
            name: item.name,
            embList: [], //刺绣
            craftList: [], //工艺及辅料
            colorContrast: [], //撞色
          });
          item.craft = []; //工艺
          item.emb = []; //刺绣
          item.accessories = []; //辅料
          item.colorContrast = []; //撞色
          item.craftChooseList = []; //当前选中的craftId
          Promise.all([
            // 刺绣颜色
            this.zzEmbAction({
              category: item.id,
              type: "emb_color",
              keywords: "",
            }).then((res) => {
              res.data.map((item) => {
                item.isDefault = 0;
              });
              item.embColor = res.data;
            }),
            // 刺绣尺寸
            this.zzEmbAction({
              category: item.id,
              type: "emb_size",
              keywords: "",
            }).then((res) => {
              res.data.map((item) => {
                item.isDefault = 0;
              });
              item.embSize = res.data;
            }),
            // 撞色
            this.zzContrastAction({
              category: item.id,
              keywords: "",
            }).then((res) => {
              res.data.map((item) => {
                item.isDefault = 0;
              });
              item.colorContrastFabric = res.data;
            }),
            // 刺绣文字
            this.zzEmbAction({
              category: item.id,
              type: "emb_font",
              keywords: "",
            }).then((res) => {
              res.data.map((item) => {
                item.isDefault = 0;
              });
              item.embFont = res.data;
            }),
          ]).then((result) => {
            if (item.craftList.length == 0) {
              return;
            }
            item.craftList.map((citem) => {
              if (citem.children && citem.children.length > 0) {
                this.setParentIds(citem);
              }
              if (citem.category == 1) {
                //1为工艺
                item.craft.push(citem);
                // 查看是否存在默认工艺 赋值已选择的id
                this.craftForChoose(citem, item);

                this.handSearchCraftCraftIds(citem, item);
              } else if (citem.category == 2) {
                //2为刺绣
                if (
                  citem.children[0].children &&
                  citem.children[0].children.length > 0
                ) {
                  citem.children[0].children.map((eitem) => {
                    // 刺绣详情信息赋值便于储存刺绣位置信息
                    this.$set(
                      eitem,
                      "embContent",
                      JSON.parse(JSON.stringify(this.embContent))
                    );
                    this.$set(eitem, "check", false);
                    eitem.embFont = JSON.parse(JSON.stringify(item.embFont));
                    eitem.embColor = JSON.parse(JSON.stringify(item.embColor));
                    eitem.embSize = JSON.parse(JSON.stringify(item.embSize));
                  });
                  this.$set(item, "emb", citem.children[0].children);
                }
              } else if (citem.category == 3) {
                //3为辅料
                item.accessories.push(citem);
              } else if (citem.category == 4) {//撞色
                citem.children[0].children.map((contrastItem) => {
                  this.$set(contrastItem, "check", false);
                  this.$set(contrastItem, "chooseFabric", "");
                  this.$set(contrastItem, "chooseFabricCode", "");
                });
                citem.children[0].children.map((eitem) => {
                  this.$set(
                    eitem,
                    "colorContrastFabric",
                    JSON.parse(JSON.stringify(item.colorContrastFabric))
                  );
                });
                this.$set(item, "colorContrast", citem.children[0].children);
              }
            });
          });
        });
        this.categroyMsg = res.data;
        if (this.$route.query.orderId) {
          this.editOrder();
        } else {
          this.specBodyParams.sizeType = this.tailoredList[0].id;
          this.measureInfo("");
          this.specBody();
        }
      });
    },
    // 递归插入已选择的id
    craftForChoose(e, item) {
      if (e.isDefault == 1) {
        item.craftChooseList.push(e.code);
        if (
          (e.isDefault == 1 || e.sourceType == "LABEL") &&
          e.children &&
          e.children.length > 0
        ) {
          e.children.map((citem, cindex) => {
            this.craftForChoose(citem, item);
          });
        }
      }
    },
    // 选择面料
    fabricsSlect(e) {
      this.ctmShow = false;
      // 将输入的面料置空
      this.iptFabric = "";
      this.fabricList[e].check = !this.fabricList[e].check;
      this.fabricList.map((item, index) => {
        if (index != e) {
          item.check = false;
        }
      });
    },
    // 输入刺绣内容
    embContents(e) {
      let allindex = e.target.dataset.allindex;
      let eindex = e.target.dataset.eindex;
      this.categroyMsg[allindex].emb[eindex].embContent.embContent =
        e.target.value;
      this.categroyMsg[allindex].emb.splice(
        eindex,
        1,
        this.categroyMsg[allindex].emb[eindex]
      );
    },
    // 上一步
    previous() {
      if (this.stepId > 1) {
        this.stepId--;
      }
    },
    // 下一步
    next() {
      // 第一步时校验尺寸
      if (this.stepId == 1) {
        // this.checkEmb();
        if (this.checkEmb() == false) {
          this.$Message.error(this.enmTips);
          return;
        }
        if (this.checkInput() == false) {
          this.$Message.error(this.accessoriesTips);
          return;
        }
      }
      if (this.stepId == 2) {
        if (this.checkInputCraft() == false) {
          this.$Message.error(this.craftTips);
          return;
        }
      }
      if (this.stepId < 4) {
        this.stepId++;
      }
    },
    // 第一步点击next校验刺绣
    checkEmb() {
      let pass = true;
      // let tips = ''
      for (let i = 0; i < this.categroyMsg.length; i++) {
        // if(this.categroyMsg[i].emb.length>0){
        for (let c = 0; c < this.categroyMsg[i].emb.length; c++) {
          // 如果选择了
          if (this.categroyMsg[i].emb[c].check) {
            if (this.categroyMsg[i].emb[c].currentExtension === "file") {
              if (!this.categroyMsg[i].emb[c].file) {
                pass = false;
                this.enmTips =
                  this.categroyMsg[i].name +
                  ":" +
                  this.$t("newOrder.pinputEmb") +
                  this.categroyMsg[i].emb[c].name +
                  this.$t("newOrder.file");
                return pass;
              }
            } else {
              if (this.categroyMsg[i].emb[c].embContent.embContent == "") {
                pass = false;
                this.enmTips =
                  this.categroyMsg[i].name +
                  ":" +
                  this.$t("newOrder.pinputEmb") +
                  this.categroyMsg[i].emb[c].name +
                  this.$t("newOrder.content");
                return pass;
              }
            }
            //  处理颜色
            if (
              this.categroyMsg[i].emb[c].embColor.length > 0 &&
              this.categroyMsg[i].emb[c].embContent.color == ""
            ) {
              pass = false;
              this.enmTips =
                this.categroyMsg[i].name +
                ":" +
                this.$t("newOrder.pselectEmb") +
                this.categroyMsg[i].emb[c].name +
                this.$t("newOrder.color");
              return pass;
            }
            // 处理字体
            if (
              this.categroyMsg[i].emb[c].embFont.length > 0 &&
              this.categroyMsg[i].emb[c].embContent.font == ""
            ) {
              pass = false;
              this.enmTips =
                this.categroyMsg[i].name +
                ":" +
                this.$t("newOrder.pselectEmb") +
                this.categroyMsg[i].emb[c].name +
                this.$t("newOrder.font");
              return pass;
            }
            // 处理大小
            if (
              this.categroyMsg[i].emb[c].embSize.length > 0 &&
              this.categroyMsg[i].emb[c].embContent.embSize == ""
            ) {
              pass = false;
              this.enmTips =
                this.categroyMsg[i].name +
                ":" +
                this.$t("newOrder.pselectEmb") +
                this.categroyMsg[i].emb[c].name +
                this.$t("newOrder.size");
              return pass;
            }
          }
        }
      }
    },
    // 第一步点next校验输入框是否有值
    checkInput() {
      for (let i = 0; i < this.categroyMsg.length; i++) {
        for (let ii = 0; ii < this.categroyMsg[i].accessories.length; ii++) {
          let pass = this.checkInputDeep(
            this.categroyMsg[i].accessories[ii].children
          );
          if (pass == false) {
            return false;
            break;
          }
        }
      }
    },
    // 工艺子集在父级赋值
    setParentIds(parent) {
      parent.childIds = "";
      parent.children.map((item) => {
        parent.childIds = parent.childIds + item.id + ",";
        if (item.children) {
          this.setParentIds(item);
        }
      });
    },
    checkInputDeep(e) {
      if(e&&e.length>0){

        for (let i = 0; i < e.length; i++) {
          if (e[i].children && e[i].children > 0) {
            this.checkInputDeep(e[i].children);
          } else {
            if (
              e[i].sourceType == "TEXT" &&
              (!e[i].value || e[i].value == "") &&
              e[i].isDefault == 1
            ) {
              this.accessoriesTips =
                this.$t("newOrder.pleaseFillIn") +
                e[i].name +
                this.$t("newOrder.content");

              return false;
              break;
            }
          }
        }
      }
    },
    // 第二步点next校验输入框是否有值
    checkInputCraft() {
      for (let i = 0; i < this.categroyMsg.length; i++) {
        for (let ii = 0; ii < this.categroyMsg[i].craft.length; ii++) {
          let pass = this.checkInputCraftDeep(
            this.categroyMsg[i].craft[ii].children
          );
          if (pass == false) {
            return false;
            break;
          }
        }
      }
    },
    checkInputCraftDeep(e) {
      for (let i = 0; i < e.length; i++) {
        if (e[i].children && e[i].children > 0) {
          this.checkInputCraftDeep(e[i].children);
        } else {
          if (
            e[i].sourceType == "TEXT" &&
            (!e[i].value || e[i].value == "") &&
            e[i].isDefault == 1
          ) {
            this.accessoriesTips =
              this.$t("newOrder.pleaseFillIn") +
              e[i].name +
              this.$t("newOrder.content");

            return false;
            break;
          }
        }
      }
    },
    //**右侧显示部分
    // 右侧显示工艺  //显示工艺   当前级别寻子集
    setRightCraft(detailList, citem) {
      citem.children.map((childItem) => {
        if (childItem.isDefault == 1) {
          //选中
          this.chooseIds = this.chooseIds + childItem.id + ",";
          detailList.push({
            parentName: citem.name, //父级
            name: childItem.name, //名字
            price: childItem.price, //价格
            url: childItem.craftPath, //所选工艺的图片
          });
          if (
            childItem.sourceType == "LABEL" &&
            childItem.children.lengtn > 0
          ) {
            this.setRightCraft(detailList, childItem);
          }
        }
      });
    },

    //**提交部分 */

    // 工艺赋值
    setCraftMap(crafChildren, detailsMsg) {
      if (!crafChildren) {
        return;
      }
      crafChildren.map((item, index) => {
        if (item.sourceType != "LABEL" && item.isDefault == 1) {
          if (item.sourceType == "TEXT") {
            detailsMsg.craftList.push({
              craftId: item.id,
              content: item.value,
            });
          } else {
            detailsMsg.craftList.push({
              craftId: item.id,
              content: "",
            });
          }
          if (item.children) {
            this.setCraftMap(item.children, detailsMsg);
          }
        } else {
          if (item.children) {
            this.setCraftMap(item.children, detailsMsg);
          }
        }
      });
    },
    // 刺绣赋值  刺绣有些数据输入为空时 给提示
    setEmbs(cateItem, detailsMsg) {
      cateItem.emb.map((embItem, embIndex) => {
        if (embItem.check) {
          embItem.embContent.site = embItem.id;
          embItem.embContent.href = embItem.href;
          embItem.embContent.file = embItem.file;
          detailsMsg.embList.push(embItem.embContent);
          if (this.$route.query.orderId) {
            if (embItem.file) {
              this.$set(embItem.embContent, "sourceType", "edit");
            }
          } else {
            if (embItem.file) {
              this.$set(embItem.embContent, "sourceType", "add");
            }
          }
        }
      });
    },
    // 客户信息赋值
    setCustomer() {
      let pass = true;
      for (var i = 0; i < this.basicList.length; i++) {
        if (this.basicList[i].must && this.basicList[i].inputValue == "") {
          pass = false;
          this.$Message.error(
            this.$t("customer.saveTips." + this.basicList[i].label)
          );
          break;
        }
      }
      if (pass) {
        this.submitOrder.customerName = this.basicList[0].inputValue;
        this.submitOrder.shortName = this.basicList[1].inputValue;
        this.submitOrder.genderId = this.basicList[2].value;
        this.submitOrder.height = this.basicList[3].inputValue;
        this.submitOrder.heightUnit = this.basicList[3].value;
        this.submitOrder.weight = this.basicList[4].inputValue;
        this.submitOrder.weightUnit = this.basicList[4].value;
        this.submitOrder.phone = this.basicList[5].inputValue;
        this.submitOrder.email = this.basicList[6].inputValue;
        this.submitOrder.address = this.basicList[7].inputValue;
        this.submitOrder.birthdate = this.basicList[8].inputValue;
      }
      return pass;
    },
    //**  特体信息赋值
    setSpecialBody() {
      this.submitOrder.bodyTypeList = [];
      this.styleList.map((item) => {
        if (item.chooseId) {
          this.submitOrder.bodyTypeList.push(item.chooseId);
        }
      });
    },
    //**  尺寸赋值
    setSize(cloItem, detailsMsg) {
      let pass = true;
      for (let i = 0; i < cloItem.sizeList.length; i++) {
        if (
          !cloItem.sizeList[i].disabled &&
          cloItem.sizeList[i].isMust == 1 &&
          (cloItem.sizeList[i].inputValue == "" ||
            !cloItem.sizeList[i].inputValue)
        ) {
          this.$Message.error(
            cloItem.sizeList[i].name + " " + this.$t("newOrder.cannotEmpty")
          );
          pass = false;
          return false;
        } else if (
          !cloItem.sizeList[i].disabled &&
          cloItem.sizeList[i].inputValue &&
          (cloItem.sizeList[i].inputValue > cloItem.sizeList[i].maxValue ||
            cloItem.sizeList[i].inputValue < cloItem.sizeList[i].minValue)
        ) {
          this.$Message.error(
            cloItem.sizeList[i].name + " " + this.$t("newOrder.scope")
          );
          pass = false;
          return false;
        }
      }

      if (pass == false) {
        return;
      }
      detailsMsg.shape = "";
      detailsMsg.sizeList = [];
      detailsMsg.styleId = "";
      if (this.submitOrder.sizeCategoryId === 10054) {
        // 标准号设置号型
        detailsMsg.shape = cloItem.chosoeId;
      } else if (this.submitOrder.sizeCategoryId === 10052) {
        // 净体设置着装风格
        detailsMsg.styleId = cloItem.chooseStyleId;
      } else {
      }
      cloItem.sizeList.map((sizeItem) => {
        if (sizeItem.disabled) return false;
        detailsMsg.sizeList.push({
          partValue: sizeItem.inputValue,
          partId: sizeItem.id,
          modifyValue:
            this.standardChoose == "size"
              ? sizeItem.inputValue - sizeItem.defaultValue
              : "",
        });
      });
      return pass;
    },
    //**撞色赋值
    setColorContrast(contrastItem, detailsMsg) {
      if (contrastItem.chooseFabric && contrastItem.check) {
        //选中并存在选择撞色面料
        detailsMsg.contrastSaveList.push({
          color: contrastItem.chooseFabric,
          site: contrastItem.id,
        });
      }
    },
    // 获取接口返回数据中有用的部分
    handleGetReturnDatat(data) {
      let returnData = {};
      Object.keys(data).map((key) => {
        returnData = data[key];
      });
      return returnData;
    },
    //**提交部分 */
    // 提交
    submit(type) {
      this.submitOrder.clothCategory = this.$route.query.id;

      // 设置面料
      if (this.iptFabric) {
        //如果是输入的CTM面料
        this.submitOrder.fabric = this.iptFabric;
      } else {
        //没有输入 普通选中面料
        this.fabricList.map((item) => {
          if (item.check) {
            this.submitOrder.fabric = item.fabricCode;
          }
        });
      }
      // 面料为空提示
      if (this.submitOrder.fabric == "") {
        this.$Message.error(this.$t("newOrder.fabricRequired"));
        return;
      }
      this.submitOrder.detailList = []; //分步工艺置空
      this.categroyMsg.map((cateItem, cateIndex) => {
        // 循环当前工艺
        this.submitOrder.detailList.push(
          JSON.parse(JSON.stringify(this.detailList))
        );
        let detailsMsg = this.submitOrder.detailList[cateIndex];
        //**  赋值当前品类id
        detailsMsg.clothCategory = cateItem.id;
        //**  赋值当前选中的的工艺信息
        cateItem.craftList.map((craftItem, craftIndex) => {
          // 如果当前工艺如果不是撞色跟刺绣 循环
          if (craftItem.category == 1 || craftItem.category == 3) {
            // detailsMsg.craftMap.description
            this.setCraftMap(craftItem.children, detailsMsg);
          }
        });
        if (cateItem.colorContrast && cateItem.colorContrast.length > 0) {
          //如果是撞色
          cateItem.colorContrast.map((contrastItem) => {
            this.setColorContrast(contrastItem, detailsMsg);
          });
        }
        //**赋值选中的刺绣 */
        this.setEmbs(cateItem, detailsMsg);
      });
      let customerPass = this.setCustomer();
      //如果赋值成功
      if (customerPass) {
        //**客户单号赋值 */
        this.submitOrder.cusOrderCode = this.params.orderMsg.inputValue;
        //**尺寸分类赋值*/
        this.submitOrder.sizeCategoryId = this.specBodyParams.sizeType;
        //**赋值特体信息 */
        this.setSpecialBody();
        if (this.submitOrder.sizeCategoryId === 10054) {
          //标准号 选职责号型大类
          this.submitOrder.sizeAreaId = this.standardChoose.id;
        } else {
          this.submitOrder.sizeAreaId = "";
        }
        //**  尺寸赋值
        let passSize = true;
        for (let i = 0; i < this.clothing.length; i++) {
          let detailsMsg = this.submitOrder.detailList[i];
          passSize = this.setSize(this.clothing[i], detailsMsg);
          if (passSize == false) {
            break;
          }
        }
        if (passSize) {
          if (
            this.$route.query.orderId &&
            this.$route.query.orderType !== "buyagain"
          ) {
            this.submitOrder.orderId = this.$route.query.orderId;
          }

          let custInfo = {
            basicList: this.basicList,
          };
          this.submitOrder.custInfo = JSON.stringify(custInfo);
          let orderInfo = {
            fabricList: this.fabricList,
            categroyMsg: this.categroyMsg,
            params: this.params,
            standardChoose: this.standardChoose,
            styleList: this.styleList,
            clothing: this.clothing,
            isAddShow: this.isAddShow,
            basicList: this.basicList,
          };
          this.submitOrder.orderInfo = JSON.stringify(orderInfo);
          this.spinShow = true;
          if (type == "size") {
            //如果只是为了号型
            this.getFinishedSizeAction(this.submitOrder)
              .then((res) => {
                if (res.code == 0) {
                  this.garmentSize = [];
                  // this.$router.push('./successfully')
                  for (let key in res.data) {
                    this.garmentSize.push({
                      name: key,
                      list: [],
                    });
                    for (let ckey in res.data[key]) {
                      this.garmentSize[this.garmentSize.length - 1].list.push({
                        name: ckey,
                        size: res.data[key][ckey],
                      });
                    }
                  }
                } else {
                  this.$Message.error(res.message);
                }
              })
              .finally((res) => {
                this.spinShow = false;
              });
          } else if (type == "order") {
            this.submitOrderAction(this.submitOrder)
              .then((res) => {
                // cons.log("是否保存成功", res);
                if (res.code == "0") {
                  let returnData = this.handleGetReturnDatat(res.data);
                  this.$Message.success(res.message);
                  if (returnData.sign && returnData.sign === "faile") {
                    this.$router.push("/myOrder");
                  } else {
                    this.$router.push("/underProduction");
                  }
                } else {
                  this.$Message.error(res.message);
                }
              })
              .finally((res) => {
                this.spinShow = false;
              });
          } else {
            //提交订单
            this.saveOrderAction(this.submitOrder)
              .then((res) => {
                // cons.log("是否保存成功", res);
                if (res.code == 0) {
                  this.$Message.success(res.message);
                  if (
                    this.$route.query.orderType &&
                    this.$route.query.orderType === "pending"
                  ) {
                    this.$router.push("./myOrder");
                  } else {
                    this.$router.push("./saveItems");
                  }
                } else {
                  this.$Message.error(res.message);
                }
              })
              .finally((res) => {
                this.spinShow = false;
              });
          }
        }
      }
    },
    // 刺绣上传成功
    handleUploadSuccess(response, file, fileList, embItem) {
      if (response.code === 0) {
        this.$set(embItem, "file", response.data.id);
        this.$set(embItem, "fileName", response.data.name);
        this.$set(embItem, "urlPath", response.data.urlPath);
        this.$set(embItem.embContent, "embContent", "绣花专用字");
      } else {
        this.$Message.error(response.message);
      }
    },
    // 刺绣上传失败
    handleEmbUploadError(error) {
      this.$Message.error(error.message);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/deep/.ivu-select .ivu-select-dropdown {
  top: auto !important;
  max-width: 260px;
}
/deep/.ivu-input-with-suffix {
  padding-right: 0;
}
/deep/.ivu-select-item:hover {
  color: #0a4dcc;
  background: #eeeeee;
}
/deep/.ivu-select-input {
  color: #0a4dcc;
  font-weight: 700;
  font-size: 14px;
}
/deep/.ivu-select-input::-webkit-input-placeholder {
  font-weight: 400;
  font-size: 16px;
}
/deep/.ivu-icon-ios-search {
  margin-top: 3px;
}
.clothing {
  width: 1440px;
  margin: 0 auto;
}
.new-order-box {
  position: relative;
}
.new-order {
  .customer-box {
    // width: 1130px;
    // margin: 60px auto 0;
    > div {
      margin-bottom: 40px;
      margin-right: 38px;
    }
    > div:nth-child(3n + 3) {
      margin-right: 0;
    }
  }
  .new-order-step {
    width: 100%;
    min-width: 1440px;
    height: 24px;
    background: #0a4dcc;
    overflow: hidden;
    .new-order-select {
      margin: 0 37px 0 0;
    }
    /deep/.ivu-select-selection {
      height: 18px;
      line-height: 18px;
      color: #0a4dcc;
    }
    /deep/.ivu-icon {
      color: #0a4dcc;
    }
    /deep/.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
      height: 18px;
      line-height: 18px;
      color: #0a4dcc;
    }
    .step-item {
      color: #fff;
      font-size: 14px;
      .step-item-name {
        position: relative;
      }
      .step-item-choose {
        position: absolute;
        width: 0;
        height: 0;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-bottom: 4px solid #fff;
        bottom: -2px;
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
      }
    }
  }
  .title {
    opacity: 1;
    font-size: 14px;
    font-family: ArialMT;
    text-align: left;
    color: #081938;
    line-height: 16px;
    margin-left: -10px;
    color: #0a4dcc;
    font-weight: bold;
  }

  .step-o-box {
    width: 1420px;
    // height: 100vh;
    margin: 0 auto;
    // position: relative;
    .emb-name {
      width: 78px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 12px;
      margin: 0 5px;
      text-align: center;
    }
    .r-image-box {
      width: 78px;
      height: 78px;
      position: absolute;
      border: 1px solid #003888;
      border-radius: 5px;
      top: -2px;
      left: -2px;
      .iconwancheng {
        font-size: 24px;
        margin: auto;
        color: #003888;
        background: #fff;
        width: 24px;
        height: 24px;
        line-height: 24px;
        border-radius: 50%;
      }
    }
    .categroy-name {
      font-size: 14px;
      font-weight: 500;
      text-align: left;
      color: #0a4dcc;
      line-height: 16px;
      margin-bottom: 10px;
      margin-top: 10px;
    }
    .details-choose {
      width: 642px;
      background: #f8f8f8;
      padding: 20px 40px;
      overflow-y: auto;
      // height: 100vh;
      position: relative;
    }
  }
  .step-box-modular {
    margin-bottom: 20px;
    .step-box-title-box {
      margin-bottom: 10px;
    }
  }
  .input-white {
    opacity: 1;
    background: #ffffff;
    border: 1px solid rgba(8, 25, 56, 0.1);
    border-radius: 5px;
    width: 580px;
    height: 40px;
    padding: 0 10px;
    margin: 15px 0 20px;
    outline: none;
  }
  .details-content {
    width: 798px;
    position: relative;
    .details-content-img {
      width: 292px;
      margin-top: 30px;
      margin-left: 95px;
      // top: 83px;
      // left: 95px;
      background: #f1f1f1;
      // position: absolute;
    }
    .details-content-integration {
      padding: 20px 30px 0 0;
      width: 252px;
      .details-content-msg {
        width: 222px;
        // margin-top: 61px;
        .msg-item {
          padding: 4px;
          background: #f8f8f8;
          margin-bottom: 8px;
          position: relative;
          .msg-item-price {
            position: absolute;
            top: 4px;
            right: 4px;
            z-index: 99;
            font-size: 12px;
            font-weight: 500;
            color: #0a4dcc;
            line-height: 14px;
          }
          img {
            width: 44px;
            height: 44px;
            display: flex;
            margin-right: 12px;
            background: #fff;
            border-radius: 4px;
          }
          .msg-item-title {
            font-size: 14px;
            font-weight: 400;
            text-align: left;
            color: #000000;
            line-height: 16px;
          }
        }
      }
    }
  }
  .details-banner-img-box {
    position: relative;
  }
  .details-banner-img {
    width: 67px;
    // height: 80px;
    display: block;
    margin-bottom: 12px;
    border: 1px solid #506e98;
    border-radius: 5px;
  }
  .attribute {
    width: 495px;
    background: #fff;
    padding: 12px;
    // margin-top: 15px;
    .attribute-title {
      opacity: 0.7;
      font-size: 12px;
      font-family: Roboto;
      font-weight: 400;
      text-align: left;
      color: #081938;
      line-height: 14px;
    }
    .attribute-item {
      height: 26px;
      line-height: 26px;
      padding: 0 12px;
      border-radius: 3px;
      background: #f8f8f8;
      color: rgba(8, 25, 56, 0.4);
      margin-right: 8px;
      margin-top: 12px;
    }
    .attribute-item-check {
      background: #e6edf9;
      color: #0a4dcc;
      position: relative;
    }
    .attribute-item-check::after {
      width: 100%;
      height: 100%;
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      border: 1px solid #0a4dcc;
      border-radius: 3px;
    }
  }
  .step-o-box-title {
    font-size: 16px;
    font-weight: 600;
    text-align: left;
    color: #000000;
    line-height: 18px;
    margin-bottom: 15px;
  }
  .customer-info {
    padding: 20px 40px 30px;
    background: #fff;
    width: 1440px;
    margin: 0 auto 8px;
    .customer-info-title {
      margin-bottom: 7px;
    }
    .title {
      font-size: 16px;
      font-family: Arial;
      font-weight: bold;
      text-align: left;
      color: #000000;
      line-height: 18px;
    }
    .basic-info {
      width: 1360px;
      margin: 0 auto;
      .basic-info-title {
        font-size: 14px;
        font-family: Roboto;
        font-weight: 700;
        text-align: left;
        color: #000000;
        line-height: 16px;
      }
    }
    .basic-list {
      text-align: left;
      > div {
        margin-right: 38px;
        margin-top: 33px;
      }
      > div:nth-child(3n + 3) {
        margin-right: 0;
      }
    }
  }
  .dress-style {
    padding: 30px 60px 30px 40px;
    width: 1440px;
    background: #fff;
    margin: 0 auto 8px;
    .dress-style-title {
      font-size: 14px;
      font-family: Roboto;
      font-weight: 700;
      text-align: left;
      color: #000000;
      line-height: 16px;
      margin-bottom: 20px;
    }
    .dress-img {
      width: 198px;
      // height: 374px;
      background: #f8f8f8;
      border-radius: 6px;
      margin-left: 140px;
      height: 100%;
      > img {
        width: 198px;
      }
      > div {
        font-size: 12px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: center;
        color: #666666;
        line-height: 17px;
        padding: 8px;
      }
    }
  }
  .measurements {
    width: 1440px;
    padding: 30px 40px 40px;
    background: #fff;
    margin: 0 auto;
    .finished-measurements {
      font-size: 12px;
      font-family: Roboto;
      font-weight: 700;
      text-decoration: underline;
      text-align: center;
      color: #1e64d2;
      line-height: 14px;
    }
    .measurements-title {
      font-size: 16px;
      font-family: Arial;
      font-weight: bold;
      text-align: left;
      color: #000000;
      line-height: 18px;
      margin-bottom: 20px;
    }
  }
}

.step-btn {
  position: fixed;
  margin: 0 auto;
  width: 590px;
  height: 32px;
  // background: red;
  bottom: 15px;
  // left: 15px;
  z-index: 999;
  > Button {
    background: #0a4dcc;
    color: #fff;
  }
}
.step-btn-previous {
  position: fixed;
  // margin: 0 auto;
  // width: 590px;
  height: 32px;
  // background: red;
  bottom: 15px;
  // left: 15px;
  z-index: 999;
  background: #0a4dcc;
  color: #fff;
  // left:50%;
  margin-left: -274px;
}
.step-btn-next {
  position: fixed;
  // margin: 0 auto;
  // width: 590px;
  height: 32px;
  // background: red;
  bottom: 15px;
  // left: 15px;
  z-index: 999;
  background: #0a4dcc;
  color: #fff;
  // left:50%;
  margin-left: 233px;
}
.collapse {
  text-align: left;
  width: 578px;
  margin: 12px auto 0;
  .complete {
    font-size: 14px;
    font-weight: 400;
    text-decoration: underline;
    text-align: left;
    color: #0a4dcc;
    line-height: 16px;
    margin-right: 20px;
  }
  .collapse-input {
    width: 538px;
    height: 36px;
    opacity: 1;
    border: 1px solid rgba(8, 25, 56, 0.1);
    border-radius: 5px;
    outline: none;
    padding: 0 14px;
  }
  .collapse-title {
    opacity: 0.7;
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    color: #081938;
    line-height: 16px;
  }
  .collapse-search {
    width: 538px;
    margin: 20px auto 15px;
  }
}
.customer-msg {
  position: relative;
}
.step-three-options {
  position: fixed;
  bottom: 30px;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  width: 1360px;
  height: 32px;
  > Button {
    position: relative;
    z-index: 999;
  }
}
.upload-icon {
  width: 58px;
  height: 58px;
  line-height: 58px;
  text-align: center;
  border: 1px dashed #ccc;
}
.upload-icon img {
  display: block;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/newOrder/newOrder.vue